{
  "app": {
    "name": "UWU Support"
  },
  "nav": {
    "skip": "ข้ามไปเนื้อหาหลัก",
    "inbox_mine": "Inbox ของฉัน",
    "team": "ทีม",
    "team_unassigned": "ยังไม่หยิบ",
    "team_all": "ทั้งทีม",
    "all": "ทั้งหมด",
    "new_ticket": "สร้างการ์ดใหม่",
    "profile": "โปรไฟล์",
    "logout": "ออกจากระบบ",
    "palette": "ค้นหาคำสั่ง (⌘K)",
    "user_menu": "เมนูผู้ใช้",
    "open_sidebar": "เปิดเมนู",
    "group_mine": "ของฉัน",
    "view_mine": "ถืออยู่",
    "view_mentioned": "ถูก mention",
    "view_snoozed": "Snoozed",
    "view_closed": "ปิดแล้ว",
    "team_group": "ทีม {{code}}",
    "team_all_hold": "ถือทั้งทีม",
    "collapse": "ย่อแถบข้าง",
    "expand": "ขยายแถบข้าง",
    "kb": "ฐานความรู้",
    "realtime_on": "เชื่อมต่อแบบเรียลไทม์",
    "realtime_off": "ออฟไลน์ — กำลังดึงข้อมูลเป็นระยะ",
    "knowledge": "ความรู้"
  },
  "login": {
    "title": "เข้าสู่ระบบ",
    "subtitle": "ระบบ Support กลางของบริษัท — ใช้บัญชี UWU ID ของคุณ",
    "pending": "กำลังเข้าสู่ระบบ…",
    "button": "เข้าสู่ระบบด้วย UWU ID"
  },
  "loggedOut": {
    "title": "ออกจากระบบแล้ว",
    "body": "คุณออกจากระบบเรียบร้อยแล้ว",
    "again": "เข้าสู่ระบบอีกครั้ง",
    "unverified": "ระบบไม่สามารถยืนยันการออกจากระบบจากลิงก์นี้ได้ หากคุณเพิ่งออกจากระบบ ทุกอย่างเรียบร้อยดี"
  },
  "inbox": {
    "title_mine": "Inbox ของฉัน",
    "title_team_unassigned": "{{team}} · ยังไม่หยิบ",
    "title_team_all": "{{team}} · ทั้งทีม",
    "title_watching": "กำลังติดตาม",
    "title_all": "ทั้งหมด",
    "empty": "ไม่มีการ์ดในมุมมองนี้",
    "load_more": "โหลดเพิ่ม",
    "unassigned": "ยังไม่มีผู้ถือ",
    "hint": "j/k เลื่อน · Enter เปิด · / ค้นหา",
    "sort": "เรียงตาม",
    "title_mentioned": "ถูก mention",
    "title_snoozed": "Snoozed",
    "select_ticket": "เลือกการ์ด {{id}}",
    "selected_count": "เลือก {{count}} การ์ด",
    "cards_count": "{{count}} การ์ด",
    "chip_snoozed": "⏰ snoozed",
    "chip_urgent": "ด่วนมาก",
    "chip_delivery_failed": "ส่งไม่สำเร็จ",
    "triage_note": "AI เดาว่าเป็นทีม {{team}} · ความมั่นใจ {{confidence}}",
    "triage_tag": "Triage",
    "delivery_tag": "การส่ง",
    "wait_prefix": "รอ",
    "layout_list": "รายการ",
    "save_as_view": "บันทึกเป็นมุมมอง",
    "wake_prefix": "ปลุก",
    "edit_view": "แก้ไขมุมมองนี้"
  },
  "sort": {
    "last_activity_desc": "กิจกรรมล่าสุด",
    "created_desc": "สร้างใหม่สุด",
    "due_asc": "กำหนดส่งใกล้สุด",
    "priority_desc": "ความสำคัญสูงสุด"
  },
  "ticket": {
    "copy_id": "คัดลอกรหัสการ์ด",
    "copied": "คัดลอกแล้ว",
    "claim": "หยิบ",
    "transition": "เปลี่ยนสถานะ",
    "reply": "ตอบกลับ",
    "note": "โน้ตภายใน",
    "send": "ส่ง",
    "add_note": "บันทึกโน้ต",
    "placeholder_reply": "พิมพ์ข้อความตอบกลับลูกค้า…",
    "placeholder_note": "พิมพ์โน้ตภายใน (ลูกค้าไม่เห็น)…",
    "conflict": "มีการเปลี่ยนแปลงระหว่างที่คุณพิมพ์ — โหลดใหม่",
    "reload": "โหลดใหม่",
    "internal": "โน้ตภายใน",
    "system": "ระบบ",
    "holder": "ผู้ถือ",
    "requester": "ผู้เปิดเรื่อง",
    "no_messages": "ยังไม่มีข้อความ",
    "attachments": "ไฟล์แนบ {{count}} ไฟล์",
    "send_shortcut": "⌘/Ctrl+Enter เพื่อส่ง",
    "cannot_compose": "คุณไม่มีสิทธิ์เขียนในการ์ดนี้",
    "not_found": "ไม่พบการ์ด",
    "quoted": "ข้อความที่อ้างอิง",
    "scheduled_for": "กำหนดส่ง {{when}}",
    "cancel_schedule": "ยกเลิกการส่ง",
    "sent_at": "ส่งเมื่อ",
    "delivery_queued": "อยู่ในคิวส่ง",
    "delivery_sent": "ส่งแล้ว",
    "delivery_delivered": "ถึงผู้รับแล้ว",
    "delivery_bounced": "ส่งไม่สำเร็จ (bounce)",
    "delivery_failed": "ส่งไม่สำเร็จ",
    "delivery_complaint": "ผู้รับร้องเรียน",
    "back": "กลับ",
    "claim_card": "หยิบการ์ด",
    "edit_subject": "แก้ไขหัวข้อ",
    "menu": "เมนูการ์ด",
    "due_label": "ครบกำหนด",
    "conflict_typing": "การ์ดถูกแก้ระหว่างที่คุณพิมพ์ — สิ่งที่พิมพ์ไว้ยังอยู่",
    "kind_customer": "ลูกค้า",
    "kind_reply": "ตอบลูกค้า",
    "status": "สถานะ",
    "attachments_count": "ไฟล์แนบ {{count}} ไฟล์",
    "notes_count": "โน้ตภายใน {{count}} รายการ",
    "watchers_count": "ผู้ติดตาม {{count}} คน",
    "delivery_unknown": "ผลการส่งไม่แน่นอน (รอการยืนยัน — ระบบจะไม่ส่งซ้ำอัตโนมัติ)"
  },
  "composer": {
    "send": "ส่ง",
    "send_close": "ส่งและปิดการ์ด",
    "schedule": "กำหนดส่งทีหลัง…",
    "send_at": "ส่งเมื่อ",
    "schedule_confirm": "กำหนดส่ง",
    "schedule_required": "กรุณาระบุวันเวลาที่จะส่ง",
    "schedule_future": "วันเวลาต้องเป็นอนาคต",
    "schedule_too_far": "กำหนดส่งได้ไม่เกิน 30 วัน",
    "schedule_email_off": "ตั้งเวลาส่งได้เฉพาะข้อความที่ส่งอีเมล — เปิด \"ส่งอีเมลแจ้งผู้แจ้งด้วย\" ก่อน ไม่อย่างนั้นระบบจะไม่รับคำสั่งนี้",
    "more_send_options": "ตัวเลือกการส่งเพิ่มเติม",
    "mentions": "กล่าวถึง",
    "mention_remove": "นำ {{name}} ออกจากการกล่าวถึง",
    "kb_hint": "พิมพ์ /kb เพื่อค้นบทความ",
    "kb_links": "บทความที่แนบ",
    "kb_remove": "นำ {{title}} ออก",
    "kb_results": "ผลค้นหาบทความ",
    "send_if_no_reply": "ส่งถ้าลูกค้าไม่ตอบก่อน",
    "snooze_until": "พักการ์ดถึง",
    "snooze_send": "ส่ง & พัก",
    "snooze_send_confirm": "ส่งแล้วพัก",
    "to": "ถึง",
    "cc": "สำเนา",
    "add_to": "เพิ่มผู้รับ",
    "add_cc": "เพิ่มสำเนา",
    "remove_email": "นำ {{email}} ออก",
    "ai_quiet": "ให้ AI ช่วยร่าง"
  },
  "undo": {
    "sent": "ส่งแล้ว",
    "action": "เลิกทำ ({{count}})",
    "action_no_count": "เลิกทำ",
    "expired": "หมดเวลาเลิกทำแล้ว",
    "countdown_secs": "เลิกทำได้อีก {{count}} วิ"
  },
  "attach": {
    "add": "แนบไฟล์",
    "list": "ไฟล์แนบที่กำลังจะส่ง",
    "uploading": "กำลังอัปโหลด",
    "cancel": "ยกเลิกการอัปโหลด",
    "remove": "ลบไฟล์แนบ",
    "cancelled": "ยกเลิกแล้ว",
    "upload_failed": "อัปโหลดไม่สำเร็จ",
    "too_large": "ไฟล์ใหญ่เกิน 25MB",
    "risky": "ไฟล์เสี่ยง"
  },
  "handoff": {
    "button": "ส่งต่อ",
    "title": "ส่งต่อการ์ด",
    "mode": "โหมด",
    "mode_transfer": "โอน",
    "mode_child": "แตกลูก",
    "to_team": "ส่งต่อไปทีม",
    "select_team": "เลือกทีม…",
    "note": "ข้อความ",
    "requested_action": "สิ่งที่ต้องการให้ทำ",
    "due_at": "กำหนดเสร็จ",
    "submit": "ส่งต่อ",
    "return": "ส่งกลับ",
    "error_team_required": "กรุณาเลือกทีมปลายทาง",
    "error_due_invalid": "วันที่ไม่ถูกต้อง",
    "teams_unavailable": "โหลดรายการทีมไม่ได้",
    "section": "ส่วน",
    "tab_details": "รายละเอียด",
    "tab_redaction": "ปกปิดข้อมูล",
    "redaction_help": "เลือกข้อความ/ไฟล์แนบ/อีเมลที่ต้องการปกปิดก่อนส่งต่อ — ทีมปลายทางจะไม่เห็นจนกว่าจะกด \"ดู\" และใส่เหตุผล",
    "dept_unknown": "แผนก",
    "dept_intake_missing": "ยังไม่มีทีมรับเข้า เลือกทีมโดยตรงแทน"
  },
  "watchers": {
    "label": "ผู้ติดตาม {{count}} คน",
    "follow": "ติดตาม",
    "unfollow": "เลิกติดตาม"
  },
  "panel": {
    "title": "ข้อมูลการ์ด",
    "toggle": "ซ่อน/แสดงแผงข้อมูล",
    "subject": "หัวข้อ",
    "priority": "ความสำคัญ",
    "due": "กำหนดส่ง",
    "clear_due": "ล้างกำหนดส่ง",
    "tags": "แท็ก",
    "no_tags": "ไม่มีแท็ก",
    "add_tag": "เพิ่มแท็ก",
    "add_tag_placeholder": "ชื่อแท็ก…",
    "remove_tag": "ลบแท็ก {{tag}}",
    "tags_not_ready": "รายการแท็กยังไม่พร้อม",
    "custom_fields": "ฟิลด์เพิ่มเติม",
    "no_custom_fields": "ไม่มีฟิลด์เพิ่มเติม",
    "save_fields": "บันทึกฟิลด์",
    "info": "ข้อมูล",
    "service": "บริการ",
    "channel": "ช่องทาง",
    "language": "ภาษา",
    "version": "เวอร์ชัน",
    "tab_details": "รายละเอียด",
    "tab_ai": "AI",
    "tab_context": "ข้อมูลลูกค้า",
    "field_select_empty": "— เลือก —",
    "field_no_options": "ฟิลด์นี้ยังไม่มีตัวเลือก"
  },
  "priority": {
    "low": "ต่ำ",
    "normal": "ปกติ",
    "high": "สูง",
    "urgent": "ด่วน"
  },
  "search": {
    "label": "ค้นหาการ์ด",
    "placeholder": "ค้นหา… (status:open tag:vpn is:mine)",
    "clear": "ล้างการค้นหา",
    "results_for": "ผลค้นหา: {{q}}",
    "unsupported_keys": "ยังไม่รองรับตัวกรอง: {{keys}} — ไม่ได้ส่งไปค้นหา"
  },
  "views": {
    "saved": "มุมมองที่บันทึก",
    "not_ready": "saved views ยังไม่พร้อม",
    "save": "บันทึกมุมมอง",
    "save_current": "บันทึกการค้นหาปัจจุบันเป็นมุมมอง",
    "save_need_q": "พิมพ์คำค้นก่อนจึงจะบันทึกมุมมองได้",
    "save_name_prompt": "ตั้งชื่อมุมมองนี้",
    "pin": "ปักหมุด",
    "unpin": "เลิกปักหมุด",
    "create": "สร้างมุมมองใหม่",
    "name": "ชื่อ",
    "layout": "รูปแบบ",
    "layout_list": "รายการ",
    "layout_kanban": "Kanban",
    "share_team": "แชร์ให้ทีม",
    "private": "ส่วนตัว (ไม่แชร์)",
    "shared_badge": "แชร์",
    "edit": "แก้ไขมุมมอง",
    "layout_calendar": "ปฏิทิน",
    "scope": "ขอบเขตของมุมมอง",
    "field_scope": "ขอบเขต",
    "field_team": "ทีม",
    "field_q": "คำค้น",
    "field_status": "สถานะ",
    "field_sort": "เรียงตาม",
    "scope_all": "ทุกการ์ด",
    "scope_mine": "ของฉัน",
    "scope_team_unassigned": "ทีม — ยังไม่หยิบ",
    "scope_team_all": "ทีม — ทั้งหมด",
    "scope_watching": "กำลังติดตาม",
    "status_open": "เปิด",
    "status_pending_customer": "รอลูกค้า",
    "status_pending_internal": "รอภายใน",
    "status_resolved": "แก้แล้ว",
    "status_closed": "ปิด"
  },
  "portal": {
    "my_cases": "เคสของฉัน",
    "no_cases": "ยังไม่มีเคส",
    "filter_placeholder": "กรองด้วยหัวข้อ/รหัส…",
    "track": "ติดตามเคส",
    "guest_banner": "เข้าสู่ระบบด้วย UWU ID เพื่อรวมทุกเคสของคุณไว้ที่เดียว",
    "steps": "ขั้นตอนที่ดำเนินการ",
    "change_status": "เปลี่ยนสถานะเคส",
    "back_to_my": "กลับไปเคสของฉัน",
    "send_failed": "ส่งข้อความไม่สำเร็จ — ร่างข้อความและไฟล์แนบของคุณยังถูกเก็บไว้ ลองกดส่งอีกครั้งได้เลย",
    "attach_retry": "ลองอัปโหลดใหม่",
    "attach_error_blocked": "ไฟล์แนบบางไฟล์ยังส่งไม่ได้ — กด 'ลองอัปโหลดใหม่' หรือลบไฟล์ออกก่อน จึงจะส่งข้อความได้",
    "draft_locked": "เคสนี้ถูกปิดไปแล้ว — ร่างข้อความและไฟล์แนบของคุณถูกเก็บไว้ กด 'เปิดเรื่องนี้อีกครั้ง' เพื่อส่งต่อ หรือคัดลอกข้อความไปใช้กับเคสใหม่"
  },
  "guest": {
    "title": "เปิดดูเคสของคุณ",
    "intro": "เราจะส่งรหัสยืนยัน 6 หลักไปที่อีเมลที่ผูกกับลิงก์นี้",
    "request_otp": "ส่งรหัสยืนยัน",
    "enter_code": "กรอกรหัสยืนยัน",
    "code_hint": "กรอกรหัส 6 หลักจากอีเมล",
    "verify": "ยืนยัน",
    "resend": "ขอรหัสใหม่",
    "wrong_code": "รหัสไม่ถูกต้อง",
    "rate_limited": "ขอรหัสบ่อยเกินไป กรุณารอสักครู่",
    "locked": "พยายามหลายครั้งเกินไป — ล็อก 15 นาที",
    "link_linked": "อีเมลนี้ผูกกับบัญชีแล้ว กรุณาเข้าสู่ระบบ",
    "verify_unavailable": "การยืนยันตัวตนผ่านลิงก์ยังไม่เปิดใช้งานในสภาพแวดล้อมนี้"
  },
  "track": {
    "title": "ติดตามเคสด้วยรหัส",
    "ticket_id": "รหัสเคส",
    "email": "อีเมลที่ใช้เปิดเคส",
    "submit": "ส่งลิงก์ติดตาม",
    "sent": "ถ้ามีเคสตรงกับข้อมูลนี้ เราจะส่งลิงก์เข้าไปทางอีเมล",
    "hint": "การติดตามผ่านอีเมลช่วยยืนยันตัวตนคุณโดยไม่ต้องเปิดเผยสถานะเคสต่อผู้อื่น"
  },
  "event": {
    "status_changed": "เปลี่ยนสถานะ",
    "handoff_sent": "ส่งต่อการ์ด",
    "handoff_received": "รับการ์ดที่ส่งต่อมา",
    "handoff_returned": "ส่งการ์ดกลับ",
    "watcher_added": "เพิ่มผู้ติดตาม",
    "watcher_removed": "ลบผู้ติดตาม",
    "mention": "กล่าวถึง",
    "tag_added": "เพิ่มแท็ก",
    "tag_removed": "ลบแท็ก",
    "priority_changed": "เปลี่ยนความสำคัญ",
    "due_changed": "เปลี่ยนกำหนดส่ง",
    "field_changed": "แก้ฟิลด์",
    "child_created": "สร้างการ์ดลูก",
    "email_sent": "ส่งอีเมลแล้ว",
    "email_bounced": "อีเมล bounce",
    "due_soon": "ใกล้ครบกำหนด",
    "overdue": "เกินกำหนด",
    "automation_actor": "ระบบอัตโนมัติ",
    "snoozed": "พักการ์ด",
    "unsnoozed": "เลิกพัก",
    "merged": "รวมการ์ด",
    "split": "แตกการ์ด",
    "linked": "เชื่อมโยงการ์ด",
    "unlinked": "ยกเลิกเชื่อมโยง",
    "redacted": "ปกปิดข้อมูล",
    "redaction_revealed": "เปิดเผยข้อมูลที่ปกปิด",
    "automation_ran": "รันกฎอัตโนมัติ",
    "automation_error": "กฎอัตโนมัติผิดพลาด"
  },
  "safeHtml": {
    "show_external_image": "แสดงรูปภายนอก"
  },
  "new": {
    "title": "สร้างการ์ดใหม่",
    "service": "บริการ",
    "service_placeholder": "เลือกบริการ",
    "requester_email": "อีเมลผู้เปิดเรื่อง",
    "requester_name": "ชื่อผู้เปิดเรื่อง",
    "subject": "หัวข้อ",
    "body": "รายละเอียด",
    "submit": "สร้างการ์ด",
    "submitting": "กำลังสร้าง…"
  },
  "profile": {
    "title": "โปรไฟล์",
    "needs_profile": "กรุณาตั้งชื่อที่แสดงก่อนเริ่มใช้งาน",
    "display_name": "ชื่อที่แสดง",
    "locale": "ภาษา",
    "timezone": "เขตเวลา",
    "save": "บันทึก",
    "saved": "บันทึกแล้ว",
    "email": "อีเมล"
  },
  "theme": {
    "toggle": "สลับธีม",
    "system": "ตามระบบ",
    "light": "สว่าง",
    "dark": "มืด"
  },
  "lang": {
    "toggle": "สลับภาษา",
    "th": "ไทย",
    "en": "English"
  },
  "palette": {
    "title": "คำสั่ง",
    "placeholder": "พิมพ์เพื่อค้นหาคำสั่ง…",
    "empty": "ไม่พบคำสั่ง",
    "go_inbox": "ไป Inbox ของฉัน",
    "go_all": "ไปการ์ดทั้งหมด",
    "go_profile": "ไปโปรไฟล์",
    "new_ticket": "สร้างการ์ดใหม่",
    "go_mail": "ไปอีเมลของฉัน",
    "mail_settings": "ตั้งค่าอีเมล",
    "mail_quarantine": "อีเมลถูกกักกัน"
  },
  "common": {
    "working": "กำลังดำเนินการ…",
    "refreshing": "กำลังอัปเดตข้อมูล…",
    "loading": "กำลังโหลด…",
    "error": "เกิดข้อผิดพลาด",
    "retry": "ลองอีกครั้ง",
    "cancel": "ยกเลิก",
    "close": "ปิด",
    "saving": "กำลังบันทึก…",
    "not_ready": "ฟีเจอร์นี้ยังไม่พร้อม",
    "save": "บันทึก",
    "add": "เพิ่ม",
    "edit": "แก้ไข",
    "delete": "ลบ",
    "confirm_delete": "ลบรายการนี้ใช่ไหม?",
    "actions": "การกระทำ",
    "empty": "ไม่มีรายการ",
    "copy": "คัดลอก",
    "copied": "คัดลอกแล้ว",
    "unsaved_confirm": "ปิดโดยไม่บันทึก? ข้อมูลที่กรอกจะหาย",
    "mutation_failed": "บันทึกไม่สำเร็จ"
  },
  "time": {
    "now": "เมื่อสักครู่"
  },
  "presence": {
    "label": "ผู้ที่เปิดการ์ดนี้อยู่ {{count}} คน",
    "offline": "ออฟไลน์ — ใช้การรีเฟรชอัตโนมัติแทน",
    "typing_of": "{{name}} กำลังพิมพ์…",
    "collision_warning": "{{names}} กำลังพิมพ์คำตอบอยู่เหมือนกัน — เช็กก่อนส่งกันซ้ำ",
    "collision_chip": "ระวังชนกัน — มีคนกำลังตอบการ์ดนี้อยู่",
    "viewing_count": "กำลังดู {{count}} คน"
  },
  "notifications": {
    "bell": "การแจ้งเตือน ({{count}} ยังไม่อ่าน)",
    "title": "การแจ้งเตือน",
    "mark_all_read": "อ่านทั้งหมด",
    "empty": "ไม่มีการแจ้งเตือน",
    "see_all": "ดูทั้งหมด",
    "unread_only": "แสดงเฉพาะยังไม่อ่าน"
  },
  "reauth": {
    "title": "ยืนยันตัวตนใหม่",
    "body": "การทำรายการนี้ต้องยืนยันตัวตนอีกครั้งเพื่อความปลอดภัย — ยืนยันแล้วกลับมาทำรายการซ้ำได้เลย",
    "confirm": "ยืนยันตัวตนใหม่"
  },
  "notifPrefs": {
    "title": "การแจ้งเตือนที่ได้รับ",
    "subtitle": "เลือกช่องทางที่อยากได้รับต่อเหตุการณ์ — ไม่เลือก = ไม่ได้รับทางช่องนั้น",
    "event": "เหตุการณ์",
    "digest": "สรุปรวม (digest)",
    "digest_none": "ไม่สรุปรวม",
    "digest_hourly": "ทุกชั่วโมง",
    "digest_daily": "รายวัน",
    "quiet": "งดแจ้งเตือนนอกเวลาทำการ (email/push)",
    "push_disabled": "การแจ้งเตือนแบบ Push ถูกปิดใช้งานชั่วคราวในรอบวางระบบนี้ — ค่าที่ตั้งไว้ยังถูกเก็บไว้และจะมีผลเมื่อเปิดใช้งานอีกครั้ง",
    "business_hours_id": "รหัสเวลาทำการ (business hours id)",
    "business_hours_id_placeholder": "เว้นว่าง = ใช้ของทีม",
    "business_hours": "เวลาทำการของคุณ",
    "eventLabel": {
      "ticket.new_in_team_inbox": "มีการ์ดใหม่ในกล่องทีม",
      "ticket.assigned_to_me": "ได้รับการมอบหมาย",
      "ticket.handoff_received": "ได้รับการส่งต่อ",
      "ticket.returned": "การ์ดถูกส่งคืน",
      "message.customer_reply": "ลูกค้าตอบกลับ",
      "message.agent_reply": "เจ้าหน้าที่ตอบกลับ",
      "message.note": "มีโน้ตใหม่",
      "mention": "ถูกกล่าวถึง",
      "ticket.status_changed": "สถานะเปลี่ยน",
      "ticket.due_soon": "ใกล้กำหนดเสร็จ",
      "ticket.overdue": "เกินกำหนดเสร็จ",
      "ticket.escalated": "ถูกเลื่อนความรุนแรง",
      "ticket.child_closed": "การ์ดลูกถูกปิด",
      "ticket.unsnoozed": "การ์ดตื่นจากการเลื่อน",
      "redaction.revealed": "ข้อมูลถูกเปิดเผย (redaction)",
      "automation.notify": "อัตโนมัติแจ้งเตือน",
      "automation.error": "อัตโนมัติทำงานพลาด",
      "csat.received": "ได้รับคะแนน CSAT",
      "mailbox.new_mail": "มีอีเมลใหม่",
      "outbox.delivery_failed": "ส่งอีเมลไม่สำเร็จ",
      "system.digest": "สรุปรวมระบบ",
      "dsar.due": "คำขอ DSAR ใกล้ครบกำหนด",
      "side_conversation.replied": "คุยข้างเคียงมีผู้ตอบ",
      "mail.quota_warning": "โควตาอีเมลใกล้เต็ม",
      "mail.send_limit_exceeded": "เกินลิมิตการส่งอีเมล",
      "mail.send_suspended": "การส่งอีเมลถูกระงับ",
      "task.assigned_to_me": "ได้รับมอบหมายงาน",
      "task.mentioned": "ถูกกล่าวถึงในงาน",
      "task.comment_added": "มีความคิดเห็นในงาน",
      "task.status_changed": "สถานะงานเปลี่ยน",
      "task.due_soon": "งานใกล้ครบกำหนด",
      "task.overdue": "งานเลยกำหนด"
    }
  },
  "admin": {
    "title": "ผู้ดูแลระบบ",
    "not_admin": "หน้านี้สำหรับผู้ดูแลระบบเท่านั้น",
    "nav_services": "บริการ",
    "nav_mailboxes": "กล่องจดหมาย",
    "nav_teams": "ทีม",
    "nav_departments": "แผนก",
    "nav_users": "ผู้ใช้",
    "users_kind": "ประเภทผู้ใช้",
    "users_status": "สถานะผู้ใช้",
    "users_search": "ค้นหาด้วยชื่อหรืออีเมล",
    "users_pagination": "หน้ารายการผู้ใช้",
    "users_previous": "ก่อนหน้า",
    "users_next": "ถัดไป",
    "users_page": "หน้า {{page}}",
    "users_page_size": "แสดงครั้งละไม่เกิน 50 คน",
    "nav_api_clients": "API clients",
    "nav_status_sets": "ชุดสถานะ",
    "nav_priority_schemes": "ระดับความสำคัญ",
    "nav_automation": "ระบบอัตโนมัติ",
    "nav_business_hours": "เวลาทำการ",
    "nav_templates": "เทมเพลต",
    "nav_settings": "ตั้งค่า",
    "nav_audit": "ประวัติการใช้งาน",
    "nav_webhooks": "Webhooks",
    "nav_forms": "ฟอร์ม",
    "not_ready": "ส่วนนี้รอ backend ของชุด B (T-032/T-034) merge — API ยังไม่มีบน main",
    "nav_field_definitions": "ฟิลด์กำหนดเอง",
    "nav_tags": "แท็ก",
    "nav_holiday_calendars": "ปฏิทินวันหยุด",
    "fd": {
      "key": "คีย์",
      "label": "ป้ายชื่อ",
      "type": "ชนิด",
      "scope": "ขอบเขต",
      "scope_id": "รหัสขอบเขต (uuid)",
      "options": "ตัวเลือก (ทีละบรรทัด)",
      "validation_regex": "รูปแบบ (regex)",
      "validation_min": "ความยาวขั้นต่ำ",
      "validation_max": "ความยาวสูงสุด",
      "visible_if": "แสดงเมื่อ",
      "visible_if_invalid": "เงื่อนไขการแสดงไม่ถูกต้อง",
      "customer_visible": "ลูกค้าเห็น",
      "customer_editable": "ลูกค้าแก้ได้",
      "show_in_list": "แสดงในรายการ",
      "searchable": "ค้นได้",
      "sensitive": "ข้อมูลอ่อนไหว",
      "ai_extractable": "AI ดึงได้",
      "sort_order": "ลำดับ",
      "flags": "คุณสมบัติ",
      "archived": "เก็บถาวรแล้ว",
      "active": "ใช้งาน",
      "scope_global": "ทั้งระบบ",
      "scope_service": "ตามบริการ",
      "scope_team": "ตามทีม",
      "status": "สถานะ",
      "err_scope_service": "เลือกบริการก่อน (ขอบเขตตามบริการต้องมีบริการ)",
      "err_scope_team": "เลือกทีมก่อน (ขอบเขตตามทีมต้องมีทีม)",
      "err_visible_if_value": "กรอกค่าของเงื่อนไขการแสดงให้ครบ",
      "scope_service_target": "บริการ",
      "scope_team_target": "ทีม",
      "validation_preset": "รูปแบบสำเร็จ",
      "preset_none": "— เลือกเพื่อเติม regex —",
      "vis_field": "ฟิลด์ที่ตรวจ",
      "vis_op": "เงื่อนไขที่ตรวจ",
      "vis_value": "ค่า",
      "err_visible_if_between": "ค่า between ต้องเป็นตัวเลขสองคั่นด้วยลูกน้ำ เช่น 10,60"
    },
    "tags": {
      "name": "ชื่อ",
      "color": "สี",
      "description": "คำอธิบาย",
      "pick_color": "เลือกสี",
      "scope_filter_all": "ทั้งหมด"
    },
    "holidays": {
      "name": "ชื่อ",
      "dates_label": "วันหยุด (YYYY-MM-DD ทีละบรรทัด)",
      "import_thai": "นำเข้าวันหยุดราชการไทย {{year}}",
      "invalid_date": "รูปแบบวันที่ไม่ถูกต้อง: {{line}}",
      "dates_count": "{{count}} วัน",
      "years": "ปี",
      "dates": "จำนวนวัน"
    },
    "bh": {
      "holiday_calendar": "ปฏิทินวันหยุด",
      "no_calendar": "— ไม่ใช้ —",
      "timezone": "เขตเวลา",
      "add_interval": "เพิ่มช่วงของ {{day}}",
      "remove_interval": "ลบช่วงที่ {{index}} ของ {{day}}",
      "interval_start": "{{day}} ช่วง {{index}} เริ่ม",
      "interval_end": "{{day}} ช่วง {{index}} สิ้นสุด",
      "days": {
        "mon": "จันทร์",
        "tue": "อังคาร",
        "wed": "พุธ",
        "thu": "พฤหัสบดี",
        "fri": "ศุกร์",
        "sat": "เสาร์",
        "sun": "อาทิตย์"
      }
    },
    "teams": {
      "member_role": "บทบาท",
      "role_of": "บทบาทของ {{name}}",
      "already_member": "ผู้ใช้นี้เป็นสมาชิกอยู่แล้ว",
      "pick_user": "เลือกสมาชิกใหม่"
    },
    "dept": {
      "intake_team": "ทีมรับเรื่อง",
      "no_intake_team": "ยังไม่มีทีมรับเรื่อง"
    },
    "svc": {
      "intake_team": "ทีมรับเรื่อง",
      "department": "แผนก",
      "status_set": "ชุดสถานะ",
      "priority_scheme": "ระดับความสำคัญ",
      "none": "— ไม่ใช้ —"
    },
    "readiness": {
      "title": "ความพร้อมรับเคสต่อบริการ",
      "hint": "สรุปจากค่าที่ตั้งไว้ในระบบ — รายการที่ขาดมีลิงก์ไปหน้าแก้ไข",
      "ready": "พร้อมรับเคส",
      "not_ready": "ยังไม่พร้อม (ขาด {{count}} รายการ)",
      "check_intake_team": "ทีมรับเรื่อง",
      "check_workflow": "workflow",
      "check_priority": "priority",
      "check_business_hours": "เวลาทำการ",
      "check_channels": "ช่องทางรับเรื่อง",
      "fix": "แก้"
    },
    "ss": {
      "edit_title": "แก้ชื่อชุดสถานะ",
      "edit_status": "แก้ไขสถานะ {{code}}",
      "status_name": "ชื่อสถานะ",
      "status_type": "ชนิดสถานะ",
      "edit_transition": "แก้ไขทางเดิน {{from}} → {{to}}",
      "transition_roles": "ผู้เปลี่ยนได้",
      "require_note": "ต้องมีโน้ต"
    },
    "ps": {
      "edit_title": "แก้ชื่อชุดระดับความสำคัญ",
      "edit_priority": "แก้ไขระดับ {{code}}",
      "priority_name": "ชื่อระดับ",
      "priority_rank": "ลำดับ"
    },
    "nav_kb": "ฐานความรู้",
    "nav_csat": "สถิติ CSAT",
    "nav_ai": "ตั้งค่า AI",
    "nav_pdpa": "PDPA",
    "nav_feature_flags": "Feature flags",
    "nav_health": "สถานะระบบ",
    "nav_context_providers": "Context providers",
    "api_key_email_policy": {
      "read_title": "สิทธิ์อ่านอีเมล",
      "read_hint": "อ่านเฉพาะอีเมลของ client นี้ที่ตรงทั้งผู้ส่งและ stream ที่เลือก ครอบคลุมรายการ รายละเอียด receipts และ events แยกจากสิทธิ์ส่ง",
      "read_senders": "ผู้ส่งที่อ่านได้",
      "read_sender_hint": "ใส่ที่อยู่ผู้ส่งเต็ม คั่นด้วยบรรทัดใหม่หรือ comma ไม่ใช่ที่อยู่ผู้รับ",
      "read_streams": "Streams ที่อ่านได้",
      "read_prefix": "อ่าน",
      "read_legacy": "สิทธิ์อ่านเดิม: อีเมลทั้งหมดของ client นี้",
      "title": "สิทธิ์ส่งอีเมล",
      "hint": "กำหนดสิทธิ์สำหรับ key ใหม่นี้ ต้องเลือกผู้ส่งและ stream อย่างน้อยหนึ่งรายการ การดูสถานะอีเมลต้องมี email:read ด้วย",
      "senders": "ผู้ส่งที่อนุญาต",
      "sender_hint": "ใส่ที่อยู่อีเมลเต็ม คั่นด้วยบรรทัดใหม่หรือ comma ผู้ส่งต้องมี sending identity ในระบบ",
      "invalid_sender": "กรุณาใส่ที่อยู่อีเมลที่ถูกต้อง ไม่รองรับ wildcard ในหน้าจอนี้",
      "streams": "Streams ที่อนุญาต",
      "sandbox": "Sandbox — ทดสอบโดยไม่ส่งอีเมลจริง",
      "live": "ส่งจริง",
      "live_hint": "key นี้อนุญาตให้ส่งอีเมลจริงผ่าน provider ที่ระบบตั้งไว้",
      "sender_summary": "ผู้ส่ง",
      "none": "ไม่ได้ตั้งสิทธิ์ส่งอีเมล",
      "key_name": "ชื่อ key"
    },
    "api_client_services": {
      "title": "บริการที่เห็นใน feed/webhook",
      "button": "บริการ",
      "hint": "client จะเห็นการ์ดของบริการที่เลือกทุกช่องทาง (รวมที่ลูกค้าเปิดเองผ่าน portal/ฟอร์ม) นอกเหนือจากการ์ดที่ client สร้างเอง — ใช้เป็นขอบเขตของ change feed และ webhooks",
      "empty": "ยังไม่ได้เลือกบริการ — client เห็นเฉพาะการ์ดที่สร้างเอง"
    },
    "nav_mail_admin": "อีเมล (บริหาร)",
    "mail": {
      "title": "คอนโซลบริหารอีเมล",
      "hint": "บริหารโดเมน บัญชี ที่อยู่ และสิทธิ์ของแพลตฟอร์มอีเมล — สิทธิ์และความถูกต้องของค่าทุกอย่างตรวจโดยระบบฝั่งเซิร์ฟเวอร์",
      "tab_domains": "โดเมน",
      "tab_accounts": "บัญชี",
      "tab_addresses": "ที่อยู่",
      "tab_domain_admins": "ผู้ดูแลโดเมน",
      "tab_routes": "เส้นทาง",
      "forbidden": "ส่วนนี้ต้องเป็นผู้ดูแลระบบ (ตามสิทธิ์ที่ระบบกำหนด)",
      "done": "ทำรายการสำเร็จ",
      "col_domain": "โดเมน",
      "col_readiness": "ความพร้อม",
      "col_ses": "SES",
      "col_cf": "Cloudflare",
      "col_catch_all": "catch-all",
      "col_max_inbound": "รับสูงสุด (MB)",
      "col_default_quota": "โควตาเริ่มต้น (MB)",
      "col_address": "ที่อยู่",
      "col_display": "ชื่อที่แสดง",
      "col_status": "สถานะ",
      "col_quota": "โควตา",
      "col_send_limit": "ลิมิตส่ง/วัน",
      "col_kind": "ชนิด",
      "col_enabled": "เปิดใช้",
      "col_target": "เป้าหมาย",
      "col_grants": "สิทธิ์",
      "col_user": "ผู้ใช้",
      "col_pattern": "แพตเทิร์น",
      "col_priority": "ลำดับ",
      "ready": "พร้อมรับ-ส่ง",
      "not_ready": "ยังไม่พร้อม",
      "w_ses": "ยืนยัน SES (identity+DKIM)",
      "w_cf": "Cloudflare พร้อม",
      "w_routing": "เปิดเส้นทางแล้ว",
      "f_routing": "เปิดเส้นทาง (routing)",
      "f_catch_all": "catch-all",
      "f_catch_all_none": "ปิด (ไม่มี)",
      "f_catch_all_reject": "ปฏิเสธ (reject)",
      "f_catch_all_address": "ส่งต่อไปที่อยู่",
      "f_mta_sts_mode": "โหมด MTA-STS",
      "f_mta_sts_id": "MTA-STS id",
      "f_tlsrpt_rua": "TLSRPT rua",
      "f_dmarc_rua": "DMARC rua",
      "f_max_inbound": "ขนาดรับสูงสุด (MB)",
      "f_default_quota": "โควตาเริ่มต้น (MB)",
      "f_local_part": "ส่วนท้องถิ่น (หน้า @)",
      "f_domain": "โดเมน",
      "f_display_name": "ชื่อที่แสดง",
      "f_quota_mb": "โควตา (MB)",
      "f_send_limit": "ลิมิตส่ง/วัน",
      "f_user": "ผู้ใช้ที่ผูกบัญชี",
      "f_user_hint": "ไม่เลือก = สร้างล่วงหน้าให้ผู้ใช้ใหม่ (ต้องระบุทีมของผู้ถูกเชิญ)",
      "f_invite_team": "ทีมของผู้ถูกเชิญ",
      "f_invite_role": "บทบาทผู้ถูกเชิญ",
      "pending_bind": "รอผูกบัญชีผู้ใช้",
      "provision": "เพิ่มบัญชีอีเมล",
      "suspend": "ระงับ",
      "activate": "คืนสถานะ",
      "offboard": "ปิดบัญชี",
      "offboard_confirm": "ปิดบัญชีอีเมลนี้ใช่ไหม? ที่อยู่จะถูกปิดทันทีและบัญชีเข้าสู่ขั้นตอน offboard",
      "status_active": "ใช้งาน",
      "status_suspended": "ระงับ",
      "status_offboarded": "ปิดบัญชีแล้ว",
      "kind_group": "กลุ่ม",
      "kind_shared_mailbox": "กล่องร่วม",
      "kind_system": "ระบบ",
      "kind_account_hint": "ที่อยู่ชนิดบัญชี (account) สร้างผ่านการเพิ่มบัญชี (provision) เท่านั้น",
      "alias_target_kind": "ปลายทาง",
      "alias_to_account": "ส่งต่อไปบัญชี",
      "alias_to_mailbox": "ส่งต่อไปกล่องรับเรื่อง (mailbox)",
      "members": "สมาชิกกลุ่ม",
      "member_kind": "ชนิดสมาชิก",
      "member_account": "บัญชีอีเมล",
      "member_address": "ที่อยู่",
      "add_member": "เพิ่มสมาชิก",
      "remove_member": "ลบสมาชิก",
      "send_as_policy": "นโยบายส่งในนามกลุ่ม",
      "send_as_members": "สมาชิกทุกคน",
      "send_as_admins": "ผู้ดูแลเท่านั้น",
      "reply_to_group": "ตั้ง Reply-To กลับเข้ากลุ่ม",
      "handler": "ตัวจัดการระบบ",
      "mailbox": "กล่องรับเรื่อง (mailbox)",
      "create": "สร้างที่อยู่",
      "grants_title": "สิทธิ์ของที่อยู่",
      "grant_add": "เพิ่มสิทธิ์",
      "grant_account": "บัญชีอีเมล",
      "grant_rights": "สิทธิ์",
      "manage_grants": "จัดสิทธิ์",
      "right_send_as": "ส่งในนาม",
      "right_send_on_behalf": "ส่งแทน",
      "right_read": "อ่าน",
      "right_manage": "บริหาร",
      "da_grant": "มอบสิทธิ์ mail_admin",
      "da_revoke": "เพิกถอน",
      "routes_hint": "ดูอย่างเดียว — ตารางเส้นทางของระบบ (แก้ไขไม่ได้จากหน้านี้)",
      "err_target_required": "กรอกเป้าหมายของที่อยู่ให้ครบก่อนบันทึก",
      "err_grant_required": "เลือกบัญชีและสิทธิ์อย่างน้อยหนึ่งรายการ"
    },
    "api_client_archive": "เก็บ API client ถาวร",
    "api_client_archive_confirm": "เก็บ API client ถาวรและเพิกถอน keys ทั้งหมด? ประวัติการ์ดและอีเมลยังคงอยู่"
  },
  "board": {
    "title": "บอร์ด",
    "pick_view": "เลือก saved view แบบ kanban เพื่อดูบอร์ด",
    "no_kanban_views": "ยังไม่มี saved view แบบ kanban — สร้างจากแถบด้านข้างก่อน",
    "conflict": "การ์ดถูกแก้ไขไปแล้ว — โหลดใหม่แล้วลองอีกครั้ง",
    "transition_denied": "เปลี่ยนสถานะนี้ไม่ได้ (เงื่อนไขไม่ผ่าน)",
    "empty": "ไม่มีการ์ดในมุมมองนี้",
    "remaining": "ยังไม่โหลดอีก {{count}} ใบ",
    "loaded_of": "โหลดแล้ว {{loaded}}/{{total}}"
  },
  "forms": {
    "select_placeholder": "— เลือก —",
    "file_not_supported": "อัปโหลดไฟล์ยังไม่รองรับในฟอร์มนี้",
    "otp_wrong": "รหัสไม่ถูกต้อง ลองใหม่อีกครั้ง",
    "success_title": "ส่งเรื่องเรียบร้อยแล้ว",
    "success_body": "ทีมงานจะติดต่อกลับโดยเร็วที่สุด",
    "track_link": "ติดตามสถานะ",
    "guest_verify": "ยืนยันอีเมลก่อนส่ง",
    "email_placeholder": "อีเมลของคุณ",
    "send_code": "ส่งรหัส",
    "verify_code": "ยืนยันรหัส",
    "submit": "ส่งฟอร์ม",
    "otp_session_expired": "เซสชันยืนยันหมดอายุ กรุณาขอรหัสใหม่และยืนยันอีกครั้ง",
    "otp_email_changed": "อีเมลเปลี่ยนระหว่างยืนยัน กรุณาขอรหัสใหม่สำหรับอีเมลใหม่",
    "session_expired": "เซสชันของคุณหมดอายุ กรุณาเข้าสู่ระบบอีกครั้ง หรือยืนยันอีเมลด้วยรหัส OTP เพื่อส่งต่อ — ข้อมูลที่กรอกยังอยู่",
    "file_add": "แนบไฟล์",
    "file_add_aria": "แนบไฟล์สำหรับ {{field}}",
    "file_list": "รายการไฟล์แนบ",
    "file_uploading": "กำลังอัปโหลด…",
    "file_ready": "พร้อมส่ง",
    "file_retry": "อัปโหลดใหม่",
    "file_remove": "ลบไฟล์",
    "file_max_exceeded": "จำนวนไฟล์เกินที่ฟิลด์นี้รับได้",
    "file_pending_block": "ไฟล์ยังอัปโหลดไม่เสร็จ — รอหรือลบออกก่อนส่ง",
    "file_ready_count": "แนบไฟล์แล้ว {{count}} ไฟล์",
    "file_too_large": "ไฟล์ใหญ่เกิน 25 MB",
    "file_upload_failed": "อัปโหลดไม่สำเร็จ",
    "col_name": "ชื่อฟอร์ม",
    "col_status": "สถานะ",
    "publish": "เผยแพร่",
    "submissions": "ผู้ส่งฟอร์ม",
    "name_th": "ชื่อ (th)",
    "view_group": "มุมมองแก้ไข",
    "view_builder": "ตัวสร้างฟอร์ม",
    "view_json": "JSON",
    "builder_pane": "ตัวสร้างฟอร์ม",
    "palette": "เพิ่มฟิลด์",
    "add_field": "เพิ่มฟิลด์",
    "page_n": "หน้าที่ {{n}}",
    "no_pages": "ยังไม่มีหน้า",
    "properties": "คุณสมบัติฟิลด์",
    "field_key": "คีย์ฟิลด์",
    "field_label": "ป้ายชื่อฟิลด์",
    "required": "จำเป็น",
    "map_to": "แมปไปที่",
    "map_to_none": "— ไม่แมป —",
    "options": "ตัวเลือก",
    "option_value": "ค่าตัวเลือก",
    "option_label_th": "ป้ายชื่อตัวเลือก (th)",
    "add_option": "เพิ่มตัวเลือก",
    "visible_if": "แสดงเมื่อ",
    "vis_field": "ฟิลด์ที่ตรวจ",
    "vis_op": "เงื่อนไข",
    "vis_value": "ค่าที่เทียบ",
    "preview": "พรีวิว (desktop)",
    "schema_json": "Schema (JSON — pages[].fields[])",
    "json_parse_error": "JSON parse ไม่ผ่าน — ตรวจวงเล็บ/เครื่องหมายคำพูดแล้วลองอีกครั้ง",
    "json_shape_error": "schema ไม่ถูกต้อง: {{first}}",
    "err_service": "เลือกบริการก่อน",
    "open_ticket": "เปิดเคส",
    "no_ticket": "ไม่มีเคส",
    "palette.text": "ข้อความ",
    "palette.textarea": "ย่อหน้าข้อความ",
    "palette.email": "อีเมล",
    "palette.phone": "เบอร์โทร",
    "palette.number": "ตัวเลข",
    "palette.date": "วันที่",
    "palette.select": "ตัวเลือก",
    "palette.multiselect": "เลือกหลายค่า",
    "palette.radio": "ตัวเลือกแนวนอน",
    "palette.checkbox": "กล่องติ๊ก",
    "palette.consent": "การยินยอม",
    "palette.ticket_ref": "อ้างอิงเคส",
    "palette.section": "หัวข้อย่อย",
    "palette.hidden": "ซ่อนไว้",
    "palette.file": "แนบไฟล์",
    "move_up": "ขึ้น",
    "move_down": "ลง"
  },
  "snooze": {
    "title": "พักการ์ด",
    "preset_1h": "1 ชั่วโมง",
    "preset_tomorrow": "พรุ่งนี้เช้า",
    "preset_next_week": "สัปดาห์หน้า",
    "until": "พักจนถึง",
    "submit": "พัก",
    "error_required": "เลือกเวลาก่อน",
    "error_future": "ต้องเป็นเวลาในอนาคต",
    "error_too_far": "พักได้ไม่เกิน 90 วัน",
    "badge": "พักถึง {{when}}",
    "cancel": "เลิกพัก",
    "scope": "ขอบเขตการพัก",
    "scope_card": "ทั้งการ์ด",
    "scope_me": "เฉพาะฉัน",
    "me_empty_hint": "ไม่ระบุเวลา = ถอนการพักส่วนตัวของคุณ",
    "withdraw": "ถอน"
  },
  "merge": {
    "title": "รวมการ์ด",
    "search_label": "ค้นหาการ์ดปลายทาง",
    "search_placeholder": "พิมพ์หัวข้อ/เลขการ์ด…",
    "error_required": "เลือกการ์ดปลายทางก่อน",
    "note": "การ์ดนี้ (v{{version}}) จะถูกรวมเข้าปลายทางที่เลือก — ยกเลิกไม่ได้",
    "submit": "รวม"
  },
  "pickers": {
    "search": "ค้นหาด้วยชื่อ…",
    "options": "ตัวเลือก",
    "type_more": "พิมพ์อย่างน้อย 2 ตัวอักษรเพื่อค้นหา",
    "no_match": "ไม่พบรายการที่ตรงกับคำค้น",
    "load_error": "โหลดรายการไม่สำเร็จ",
    "load_more": "โหลดเพิ่ม",
    "loading_more": "กำลังโหลดเพิ่ม…",
    "loaded_count": "แสดงอยู่ {{count}} รายการ",
    "showing_all": "ทั้งหมด {{count}} รายการ",
    "selected_count": "เลือกอยู่ {{count}} รายการ",
    "remove": "นำออก: {{label}}",
    "clear": "ล้างค่าที่เลือก",
    "user": {
      "label": "เลือกผู้ใช้",
      "placeholder": "ค้นหาคนด้วยชื่อหรืออีเมล…"
    },
    "team": {
      "label": "เลือกทีม",
      "placeholder": "ค้นหาทีม…",
      "no_department": "ไม่สังกัดแผนก"
    },
    "department": {
      "label": "เลือกแผนก",
      "placeholder": "ค้นหาแผนก…",
      "intake_ready": "มีทีมรับเข้า",
      "intake_missing": "ยังไม่มีทีมรับเข้า"
    },
    "service": {
      "label": "เลือกบริการ",
      "placeholder": "ค้นหาบริการ…",
      "archived": "จัดเก็บแล้ว"
    },
    "ticket": {
      "label": "เลือกการ์ด",
      "placeholder": "พิมพ์หัวข้อ/เลขการ์ด…"
    },
    "category": {
      "label": "เลือกหมวด",
      "placeholder": "ค้นหาหมวด…",
      "none": "ไม่มีหมวดแม่",
      "path": "อยู่ใน: {{path}}",
      "self_or_descendant": "หมวดนี้หรือลูกหลานของหมวดที่กำลังแก้"
    }
  },
  "split": {
    "title": "แตกการ์ด",
    "select_messages": "เลือกข้อความที่จะย้ายไปการ์ดใหม่",
    "move_internal": "ย้ายโน้ตภายในจริง (ไม่ใช่คัดลอก)",
    "error_required": "เลือกข้อความอย่างน้อย 1 รายการ",
    "submit": "แตกการ์ด"
  },
  "links": {
    "title": "การ์ดที่เกี่ยวข้อง",
    "type_label": "ประเภทความสัมพันธ์",
    "target_placeholder": "เลขการ์ดปลายทาง",
    "type": {
      "relates": "เกี่ยวข้องกับ",
      "blocks": "บล็อก",
      "blocked_by": "ถูกบล็อกโดย",
      "duplicates": "ซ้ำกับ"
    },
    "blocked_warning": "การ์ดนี้ถูกบล็อกโดยการ์ดอื่น {{count}} ใบ — ยืนยันจะปิดต่อไหม?"
  },
  "redaction": {
    "view": "ดู",
    "reveal_title": "ยืนยันเพื่อดูข้อมูลที่ปกปิด",
    "reason": "เหตุผล",
    "reveal_submit": "ดูข้อมูล",
    "reveal_not_found": "หาข้อมูลการปกปิดนี้ไม่พบ",
    "revealed": "เปิดเผยแล้ว",
    "countdown": "เหลือ {{mm}}:{{ss}} นาที",
    "expired": "หมดเวลาดูแล้ว — รีเฟรชเพื่อดูใหม่",
    "candidates": "ข้อมูลที่ตรวจพบอัตโนมัติ (แตะเพื่อเพิ่ม)",
    "select_in_messages": "ลากเลือกข้อความเพื่อปกปิดช่วงนั้น",
    "attachments": "ไฟล์แนบที่จะซ่อน",
    "participant_email": "อีเมลผู้ติดต่อที่จะซ่อน",
    "error_reason_required": "ใส่เหตุผลของการปกปิดก่อน",
    "error_selection_single_message": "เลือกได้ทีละข้อความเดียวเท่านั้น"
  },
  "home": {
    "title": "มีอะไรให้เราช่วยไหมครับ",
    "subtitle": "ค้นหาคำตอบเอง หรือส่งเรื่องถึงทีมงาน ตอบกลับภายใน 1 วันทำการ",
    "search_placeholder": "ค้นหาวิธีแก้ปัญหา…",
    "popular_categories": "หมวดยอดนิยม",
    "no_answer": "ยังไม่เจอคำตอบ",
    "no_answer_body": "ส่งเรื่องถึงทีมงาน หรือดูสถานะเรื่องที่เคยส่ง",
    "new_ticket": "ส่งเรื่องใหม่",
    "track_by_id": "ติดตามด้วย ID",
    "privacy": "นโยบายความเป็นส่วนตัว",
    "sign_in": "เข้าสู่ระบบ",
    "article_count": "{{count}} บทความ",
    "top_articles": "บทความที่คนอ่านมากที่สุด"
  },
  "catalog": {
    "choose_service": "เลือกบริการที่จะแจ้งเรื่อง",
    "recommended": "แนะนำ",
    "empty_title": "ขณะนี้ยังไม่มีแบบฟอร์มสำหรับแจ้งเรื่องออนไลน์",
    "empty_body": "หากต้องการความช่วยเหลือ กรุณาติดต่อเราผ่านช่องทางด้านล่าง",
    "contact_us": "ติดต่อเรา"
  },
  "portalShell": {
    "profile": "โปรไฟล์",
    "logout": "ออกจากระบบ",
    "contact": "ติดต่อ",
    "staff_area": "ไปหน้าทีมงาน"
  },
  "kb": {
    "title": "ชื่อเรื่อง",
    "back": "กลับ",
    "results_for": "ผลค้นหาสำหรับ “{{q}}”",
    "no_results": "ไม่พบบทความที่ตรงกัน — ลองคำอื่น หรือส่งเรื่องถึงทีมงาน",
    "no_categories": "ยังไม่มีหมวดบทความ",
    "updated_at": "อัปเดตเมื่อ {{date}}",
    "read_minutes": "อ่าน {{n}} นาที",
    "helpful_q": "บทความนี้ช่วยคุณได้ไหม",
    "helpful_yes": "ช่วยได้",
    "helpful_no": "ยังไม่ได้",
    "feedback_thanks": "ขอบคุณสำหรับความคิดเห็น",
    "comment_placeholder": "บอกเราเพิ่มเติมว่าขาดอะไร (ไม่บังคับ)",
    "comment_send": "ส่งความคิดเห็น",
    "comment_skip": "ข้าม",
    "related": "บทความที่เกี่ยวข้อง",
    "still_need_help": "ยังต้องการความช่วยเหลือ",
    "categories": "หมวดหมู่",
    "cat_new": "หมวดใหม่",
    "cat_edit": "แก้หมวด",
    "cat_name": "ชื่อหมวด",
    "slug": "slug",
    "visibility": "การมองเห็น",
    "vis_public": "สาธารณะ",
    "vis_authenticated": "ผู้ล็อกอิน",
    "vis_staff": "เจ้าหน้าที่",
    "vis_team": "ทีม",
    "parent": "หมวดแม่",
    "sort": "ลำดับ",
    "filter_status": "กรองสถานะ",
    "filter_category": "รหัสหมวด (uuid)",
    "all_statuses": "ทุกสถานะ",
    "article_new": "บทความใหม่",
    "slug_taken": "slug นี้ถูกใช้แล้ว",
    "tz_label": "เวลาท้องถิ่น {{tz}}",
    "ai_stash_hint": "มีร่างบทความจาก AI พร้อมใช้: {{title}}",
    "editor": "ตัวแก้ไขบทความ",
    "status": "สถานะ",
    "status_draft": "ร่าง",
    "status_review": "รอรีวิว",
    "status_published": "เผยแพร่",
    "status_archived": "เก็บ",
    "views": "ยอดชม",
    "helpful": "ช่วยได้",
    "attach_count": "แนบในคำตอบ",
    "publish_at": "เผยแพร่เมื่อ",
    "expire_at": "หมดอายุเมื่อ",
    "tags": "แท็ก",
    "versions": "เวอร์ชัน",
    "version_new": "เวอร์ชันใหม่",
    "lang": "ภาษา",
    "excerpt": "คำโปรย",
    "body_html": "เนื้อหา (HTML)",
    "machine_translated": "แปลด้วยเครื่อง",
    "machine_tag": "MT",
    "current": "ใช้งาน",
    "publish_version": "เผยแพร่",
    "no_versions": "ยังไม่มีเวอร์ชัน",
    "to_review": "ส่งรีวิว",
    "to_published": "เผยแพร่บทความ",
    "to_archived": "เก็บถาวร",
    "preview": "พรีวิว",
    "updated": "อัปเดต",
    "no_articles_in_category": "ยังไม่มีบทความในหมวดนี้",
    "category": "หมวด",
    "category_of_article": "หมวดของบทความ",
    "filter_category_label": "กรองตามหมวด",
    "add_child": "เพิ่มหมวดย่อย",
    "move": "ย้าย",
    "move_category": "ย้ายหมวด",
    "delete_category": "ลบหมวด",
    "cat_delete_confirm": "ลบหมวด “{{name}}” ใช่ไหม?",
    "cat_move_hint": "หมวด “{{name}}” มี {{articles}} บทความ และ {{children}} หมวดย่อย — เลือกหมวดปลายทาง ระบบจะย้ายทุกอย่างไปก่อนลบ",
    "move_target": "ย้ายไปยังหมวด",
    "move_and_delete": "ย้ายและลบ",
    "who_can_read": "ใครอ่านได้",
    "who_public": "ทุกคน รวมถึงผู้เยี่ยมชมที่ยังไม่ล็อกอิน",
    "who_authenticated": "ผู้ที่ล็อกอินแล้วเท่านั้น",
    "who_staff": "เจ้าหน้าที่ทุกคน",
    "who_team": "เฉพาะสมาชิกทีมที่เลือก",
    "team_required": "visibility = ทีม ต้องเลือกทีมก่อนบันทึก",
    "edit_content": "แก้เนื้อหา",
    "toolbar": "เครื่องมือจัดรูปแบบ",
    "fmt_h2": "หัวข้อรอง (H2)",
    "fmt_h3": "หัวข้อย่อย (H3)",
    "fmt_bold": "ตัวหนา",
    "fmt_italic": "ตัวเอียง",
    "fmt_ul": "รายการ",
    "fmt_ol": "รายการตัวเลข",
    "fmt_quote": "ข้อความอ้างอิง",
    "fmt_link": "ลิงก์",
    "link_url_prompt": "URL ของลิงก์:",
    "html_note": "โหมด HTML — แก้แท็กตรง ๆ ได้ทุกจุด (สำหรับผู้เชี่ยวชาญ)",
    "preview_draft": "พรีวิวฉบับร่าง",
    "preview_lang": "ภาษาที่แสดง",
    "preview_version": "เวอร์ชันที่แสดง",
    "archive_confirm": "เก็บถาวร “{{slug}}” ใช่ไหม?\nบทความจะหายจากฐานความรู้สาธารณะและการค้นหา สร้างเวอร์ชันใหม่/เผยแพร่ต่อไม่ได้ — ย้อนกลับไม่ได้",
    "archived_notice": "บทความถูกเก็บถาวรแล้ว — แก้เนื้อหาหรือเผยแพร่ต่อไม่ได้",
    "review_permission_hint": "เผยแพร่เป็นสิทธิ์ของหัวหน้าทีม/ผู้ดูแล",
    "load_more": "โหลดเพิ่ม",
    "loaded_of_total": "แสดง {{loaded}} จาก {{total}} บทความ",
    "matches": "พบ {{count}} ผลลัพธ์",
    "showing_top": "แสดง {{shown}} อันดับแรก"
  },
  "otp": {
    "title": "กรอกรหัส 6 หลัก",
    "sent_to": "เราส่งรหัสไปที่",
    "valid_minutes": "รหัสใช้ได้ {{minutes}} นาที",
    "not_received": "ยังไม่ได้รับรหัส",
    "resend_in": "ส่งใหม่ได้ใน {{time}}",
    "resend": "ส่งรหัสใหม่",
    "attempts_left": "เหลืออีก {{count}} ครั้ง",
    "confirm_submit": "ยืนยันและส่งเรื่อง",
    "have_account": "มีบัญชี UWU ID อยู่แล้ว?",
    "login": "เข้าสู่ระบบ",
    "login_benefit": "เพื่อข้ามขั้นตอนนี้และเห็นทุกเคสในที่เดียว",
    "input_label": "รหัสยืนยัน 6 หลัก",
    "edit_answers": "แก้ไขข้อมูลก่อนส่ง"
  },
  "guest2": {
    "verify_title": "ยืนยันว่าเป็นคุณ เพื่อเปิดเคสนี้",
    "intro_with_id": "ลิงก์นี้มาจากอีเมลแจ้งความคืบหน้าของเคส {{id}} เพื่อความปลอดภัย เราจะส่งรหัสยืนยันไปที่อีเมลของคุณอีกครั้ง",
    "intro_no_id": "เพื่อความปลอดภัย เราจะส่งรหัสยืนยันไปที่อีเมลที่ใช้เปิดเคสนี้อีกครั้ง",
    "send_to": "ส่งรหัสไปที่",
    "email_unknown": "อีเมลที่ใช้เปิดเคส",
    "link_valid_hours": "ลิงก์นี้ใช้ได้ {{hours}} ชั่วโมง และเปิดได้เฉพาะเคสนี้กับเคสที่เกี่ยวข้อง",
    "expired_title": "ลิงก์หมดอายุแล้ว",
    "expired_body": "ลิงก์นี้หมดอายุหรือถูกยกเลิกแล้ว ขอลิงก์ใหม่ หรือเข้าสู่ระบบเพื่อดูเคสของคุณ",
    "request_new": "ขอลิงก์ใหม่",
    "login_uwu": "เข้าด้วย UWU ID"
  },
  "mycase": {
    "chip_all": "ทั้งหมด {{count}}",
    "chip_active": "กำลังดำเนินการ {{count}}",
    "chip_closed": "ปิดแล้ว {{count}}",
    "st_received": "รับเรื่องแล้ว",
    "st_waiting": "รอคุณตอบกลับ",
    "st_working": "ทีมกำลังแก้ไข",
    "st_closed": "ปิดแล้ว",
    "unread": "ตอบใหม่",
    "team_line": "ทีม {{team}}",
    "updated_prefix": "อัปเดต",
    "closed_prefix": "ปิดเมื่อ",
    "csat_rated": "ให้คะแนนแล้ว {{score}}/{{max}}",
    "csat_until": "ให้คะแนนได้ถึง {{date}}",
    "new_ticket": "ส่งเรื่องใหม่",
    "cared_by": "ดูแลโดยทีม {{team}} · เปิดเมื่อ {{date}}",
    "you": "คุณ",
    "team_fallback": "ทีมงาน",
    "step_received": "รับเรื่องแล้ว",
    "step_claimed": "ทีมงานรับผิดชอบ",
    "step_working": "ทีมกำลังแก้ไข",
    "step_done": "แก้ไขเสร็จสิ้น",
    "step_duration": "ใช้เวลา {{duration}}",
    "step_started": "เริ่ม {{date}} · ผ่านมา {{duration}}",
    "step_todo": "ยังไม่ถึงขั้นนี้",
    "composer_placeholder": "พิมพ์ข้อความถึงทีมงาน…",
    "add_cc": "เพิ่มผู้รับสำเนา",
    "cc_placeholder": "อีเมลผู้รับสำเนา (คั่นด้วย , )",
    "close_self": "ปิดเคสนี้เอง",
    "close_confirm": "ยืนยันปิดเคสนี้?",
    "send": "ส่ง",
    "send_message": "ส่งข้อความ",
    "rated": "ให้คะแนนแล้ว {{score}}/5",
    "rate_until": "ให้คะแนนได้ถึง {{date}}",
    "chip_loaded": "โหลดแล้ว {{count}}"
  },
  "csat": {
    "title": "ทีมงานช่วยคุณได้ดีแค่ไหน",
    "comment_placeholder": "เล่าเพิ่มได้ว่าอะไรดี หรืออะไรควรปรับ (ไม่บังคับ)",
    "submit": "ส่งคะแนน",
    "note": "ให้คะแนนได้ภายใน 14 วันหลังปิดเคส และแก้คะแนนได้",
    "thanks_title": "ขอบคุณสำหรับคะแนน",
    "thanks_body": "ความคิดเห็นของคุณช่วยให้เราดีขึ้น",
    "comment_send": "ส่งความคิดเห็น",
    "invalid": "ลิงก์ให้คะแนนนี้ใช้ไม่ได้หรือหมดอายุแล้ว",
    "team_id": "ทีม (uuid)",
    "since": "ตั้งแต่",
    "count": "{{count}} คะแนน",
    "responses": "จำนวน",
    "avg": "คะแนนเฉลี่ย",
    "distribution": "การกระจายคะแนน",
    "by_agent": "ตามเจ้าหน้าที่",
    "agent": "เจ้าหน้าที่",
    "team": "ทีม"
  },
  "deflect": {
    "title": "บทความนี้อาจตอบคำถามคุณได้ทันที",
    "continue_note": "ถ้ายังไม่ตรง ส่งเรื่องต่อได้เลย"
  },
  "submit2": {
    "next": "ถัดไป",
    "submit": "ส่งเรื่อง",
    "email_invalid": "รูปแบบอีเมลไม่ถูกต้อง",
    "no_attach": "แนบไฟล์ยังไม่รองรับ",
    "otp_email_label": "อีเมลสำหรับรับรหัสยืนยัน",
    "otp_title": "ยืนยันอีเมล"
  },
  "track2": {
    "desc": "ไม่ต้องเข้าสู่ระบบ เราจะส่งลิงก์เปิดเคสไปที่อีเมลของคุณ",
    "submit": "ส่งลิงก์เข้าอีเมล",
    "nondisclosure": "ถ้ามีเคสที่ตรงกับข้อมูลนี้ เราจะส่งอีเมลให้ภายในไม่กี่นาที ระบบจะไม่เปิดเผยว่ามีเคสอยู่จริงหรือไม่"
  },
  "ai": {
    "sentiment_section": "อารมณ์/ความเร่งด่วน",
    "sentiment_neg": "ลบ",
    "sentiment_neu": "กลาง",
    "sentiment_pos": "บวก",
    "urgency": "ความเร่งด่วน",
    "urgency_low": "ไม่เร่ง",
    "urgency_med": "ปกติ",
    "urgency_high": "ด่วน",
    "frustration": "สัญญาณความไม่พอใจ",
    "summary": "สรุปการ์ด",
    "summary_refresh": "รีเฟรชสรุป",
    "cached": "จากแคช",
    "waiting_on": "รออะไรอยู่",
    "next_steps": "ขั้นถัดไป",
    "error": "AI ใช้งานไม่ได้ตอนนี้",
    "draft": "ร่างคำตอบ",
    "tone": "น้ำเสียง",
    "tone_polite": "สุภาพ",
    "tone_short": "กระชับ",
    "tone_formal": "ทางการ",
    "draft_generate": "ร่างคำตอบ",
    "draft_insert": "แทรกในช่องพิมพ์",
    "draft_disclaimer": "AI ร่าง — ตรวจก่อนส่ง",
    "draft_badge": "AI ร่าง — ตรวจก่อนส่ง",
    "draft_badge_clear": "ลงเครื่องหมาย AI ร่าง",
    "kb_refs": "บทความที่อ้าง",
    "extracted": "ฟิลด์ที่ AI ดึงได้",
    "extracted_confirm": "ยืนยัน",
    "extracted_done": "บันทึกแล้ว",
    "translated_by": "แปลโดย AI",
    "translate_to": "แปลเป็น {{lang}}",
    "translate_show": "ดูคำแปล",
    "translate_hide": "ซ่อนคำแปล",
    "kb_draft": "แปลงเป็นบทความ",
    "duplicates_found": "พบการ์ดที่อาจซ้ำ {{count}} ใบ",
    "budget_usd_month": "งบต่อเดือน (USD)",
    "features": "ฟีเจอร์",
    "feature": "ฟีเจอร์",
    "model": "โมเดล",
    "threshold": "เกณฑ์",
    "enabled": "เปิดใช้งาน",
    "settings_hint": "เว้นว่าง = ใช้ค่าเริ่มต้นของระบบ · ปิดฟีเจอร์ = ข้ามการเรียกใช้ทั้งหมด",
    "panel_title": "AI ร่าง",
    "insert_reply": "ใส่ในกล่องตอบ",
    "redraft": "ร่างใหม่"
  },
  "triage": {
    "title": "คัดแยกเบื้องต้น",
    "feature_disabled": "ฟีเจอร์คัดแยกเบื้องต้น (triage inbox) ปิดใช้งานอยู่ — เปิดได้ที่หน้า feature flags",
    "reason": "เหตุผล AI",
    "no_reason": "ไม่มีข้อมูลเหตุผล",
    "rule_ai": "AI เสนอทีมนี้",
    "rule_email": "กฎจากอีเมล",
    "rule_manual": "กำหนดเอง",
    "alternatives": "ทางเลือกอื่น",
    "move_to": "ย้ายไปทีม",
    "stay_team": "คงทีมเดิม",
    "accept": "รับเข้า",
    "decline": "ส่งต่อ",
    "decline_submit": "ส่งต่อ",
    "to_team": "ไปทีม",
    "note": "โน้ต",
    "duplicate": "การ์ดซ้ำ",
    "duplicate_of": "ซ้ำกับการ์ดเลข",
    "duplicate_submit": "ทำเครื่องหมายซ้ำ",
    "team_filter": "กรองตามทีม",
    "all_my_teams": "ทุกทีมของฉัน",
    "count": "{{count}} การ์ด"
  },
  "calendar": {
    "title": "ปฏิทิน",
    "pick_view": "เลือกมุมมองที่บันทึกไว้ (layout = calendar)",
    "no_views": "ยังไม่มีมุมมองแบบปฏิทิน",
    "week_of": "สัปดาห์ของ {{date}}",
    "prev": "ก่อนหน้า",
    "next": "ถัดไป",
    "today": "วันนี้",
    "mode": "มุมมอง",
    "mode_month": "เดือน",
    "mode_week": "สัปดาห์",
    "day_0": "อา",
    "day_1": "จ",
    "day_2": "อ",
    "day_3": "พ",
    "day_4": "พฤ",
    "day_5": "ศ",
    "day_6": "ส",
    "no_due": "ไม่มีกำหนด ({{count}})",
    "sheet": "รายละเอียดการ์ด",
    "open_ticket": "เปิดการ์ด",
    "more": "+{{count}} อีก",
    "more_aria": "ดูทั้งหมด {{count}} ใบของวันนี้",
    "agenda_title": "กำหนดของวันที่ {{date}}",
    "capped_notice": "แสดง {{count}} ใบล่าสุด — ยังมีอีก"
  },
  "context": {
    "none": "ไม่มีข้อมูลจากบริการภายนอกสำหรับการ์ดนี้",
    "error": "ผิดพลาด",
    "new_provider": "เพิ่มผู้ให้บริการข้อมูล",
    "name": "ชื่อ",
    "url": "URL",
    "secret": "Secret",
    "secret_keep": "ไม่เปลี่ยน = เว้นว่างไว้",
    "service_codes": "รหัสบริการ (คอมมา)",
    "timeout_ms": "หมดเวลา (ms)",
    "enabled": "เปิดใช้งาน",
    "status": "สถานะล่าสุด",
    "has_secret": "ตั้ง secret แล้ว"
  },
  "pdpa": {
    "dsar": "คำขอ DSAR",
    "retention": "นโยบายเก็บข้อมูล",
    "ropa": "ROPA",
    "incidents": "เหตุการณ์ความปลอดภัย"
  },
  "dsar": {
    "new": "สร้างคำขอ",
    "detail": "รายละเอียดคำขอ",
    "subject": "เจ้าของข้อมูล",
    "subject_email": "อีเมลเจ้าของข้อมูล",
    "subject_user_id": "รหัสผู้ใช้เจ้าของข้อมูล",
    "error_subject_required": "ระบุอีเมลหรือรหัสผู้ใช้อย่างใดอย่างหนึ่ง",
    "type": "ประเภท",
    "type_access": "เข้าถึงข้อมูล",
    "type_portability": "โอนย้ายข้อมูล",
    "type_rectify": "แก้ไขข้อมูล",
    "type_erase": "ลบข้อมูล",
    "type_restrict": "จำกัดการใช้ข้อมูล",
    "type_object": "คัดค้านการใช้ข้อมูล",
    "type_withdraw_consent": "ถอนความยินยอม",
    "status": "สถานะ",
    "status_new": "ใหม่",
    "status_verifying": "กำลังตรวจสอบ",
    "status_in_progress": "กำลังดำเนินการ",
    "status_awaiting_approval": "รออนุมัติ",
    "status_approved": "อนุมัติแล้ว",
    "status_delivered": "ส่งมอบแล้ว",
    "status_closed": "ปิดแล้ว",
    "status_rejected": "ปฏิเสธ",
    "filter_status": "กรองสถานะ",
    "all_statuses": "ทุกสถานะ",
    "source": "ที่มา",
    "source_manual": "สร้างเอง",
    "source_portal": "จากพอร์ทัล",
    "source_idp": "จากระบบสมาชิก",
    "source_email": "จากอีเมล",
    "due": "ครบกำหนด",
    "notes": "โน้ต",
    "note": "โน้ต",
    "note_placeholder": "โน้ต (ไม่บังคับ)",
    "transition_to": "เปลี่ยนสถานะเป็น",
    "export": "ส่งออกข้อมูล",
    "export_status": "ผลส่งออก",
    "download": "ดาวน์โหลด",
    "link_pending": "ลิงก์กำลังเตรียม (ตรวจสอบอีกครั้งภายหลัง)",
    "anonymize_dry_run": "ทดลองลบข้อมูล (dry-run)",
    "anonymize_run": "ลบข้อมูลจริง",
    "anonymize_confirm": "ยืนยันการลบข้อมูลจริง? การดำเนินการนี้ไม่ย้อนกลับได้",
    "dry_run_summary": "สรุปการทดลอง (dry-run)",
    "run_summary": "สรุปการลบข้อมูล",
    "scheduled": "มีขั้นต่อในคิวเบื้องหลัง",
    "discovery": "ข้อมูลที่พบของบุคคลนี้",
    "disc_users": "ผู้ใช้",
    "disc_emails": "อีเมล",
    "disc_tickets": "การ์ด",
    "disc_messages": "ข้อความ",
    "disc_attachments": "ไฟล์แนบ",
    "disc_guest_links": "ลิงก์แขก",
    "disc_sessions": "เซสชัน",
    "disc_consents": "ความยินยอม",
    "disc_csat": "CSAT"
  },
  "retention": {
    "enabled": "เปิดใช้งานการลบตามรอบ (ปิด = dry-run อย่างเดียว)",
    "suspended_emails_days": "อีเมลระงับ (วัน)",
    "audit_days": "Audit log (วัน)",
    "api_logs_days": "API log (วัน)",
    "guest_link_days": "ลิงก์แขก (วัน)",
    "ai_logs_days": "AI log (วัน)",
    "notifications_days": "การแจ้งเตือน (วัน)",
    "cron_runs_days": "Cron log (วัน)",
    "closed_after_days": "การ์ดปิดแล้ว (วัน)",
    "closed_action": "การกระทำ",
    "dry_run": "ทดลองรัน (dry-run)",
    "dry_run_result": "ผลการทดลอง"
  },
  "ropa": {
    "hint": "บันทึกการประมวลผลข้อมูลส่วนบุคคล (Record of Processing Activities) — สร้างจากบริการ/ฟอร์ม/กล่องจดหมายปัจจุบัน",
    "download": "ดาวน์โหลด ROPA (markdown)"
  },
  "incidents": {
    "new": "บันทึกเหตุการณ์",
    "description": "รายละเอียด",
    "affected_scope": "ขอบเขตที่กระทบ",
    "risk": "ระดับความเสี่ยง",
    "risk_low": "ต่ำ",
    "risk_medium": "กลาง",
    "risk_high": "สูง",
    "risk_critical": "วิกฤต",
    "status": "สถานะ",
    "status_open": "เปิด",
    "status_contained": "ควบคุมแล้ว",
    "status_closed": "ปิดแล้ว",
    "status_of": "สถานะของ {{id}}",
    "detected_at": "พบเมื่อ",
    "pdpc_deadline": "กำหนดแจ้ง PDPC",
    "mark_pdpc_notified": "บันทึกว่าแจ้ง PDPC แล้ว"
  },
  "flags": {
    "hint": "คีย์ flag ที่ระบบรู้จัก (ไม่มี API แจกชื่อ — รายการตรึงฝั่งเว็บ) · rules: users ⊃ ฉัน หรือ teams ∩ ทีมฉัน หรือ percent (hash ต่อ user)",
    "on": "เปิด",
    "off": "ปิด",
    "enabled": "เปิดใช้งาน",
    "percent": "เปอร์เซ็นต์",
    "teams": "ทีม",
    "users": "ผู้ใช้",
    "summary_on": "เปิดใช้งาน",
    "summary_off": "ปิดใช้งาน",
    "summary_percent": "อัตราส่วน {{percent}}%",
    "summary_teams": "ทีม: {{teams}}",
    "summary_users": "ผู้ใช้: {{users}}",
    "summary_everyone": "ใช้กับทุกคนที่เข้าเงื่อนไขเปิด/ปิดด้านบน",
    "desc": {
      "triage.inbox": "หน้าคัดแยกการ์ดก่อนเข้าทีม",
      "ai.pii_ner": "AI ตรวจจับข้อมูลส่วนบุคคล",
      "ai.auto_translate": "AI แปลภาษาอัตโนมัติ",
      "kb.public_indexable": "ให้เสิร์ชเอนจิน index หน้า KB สาธารณะ"
    }
  },
  "health": {
    "db_ms": "Latency ฐานข้อมูล",
    "ai_spend": "ค่า AI เดือนนี้",
    "version": "เวอร์ชัน",
    "queues": "คิว",
    "queue_inbound_backlog": "อีเมลรอประมวลผล",
    "queue_outbox_queued": "อีเมลรอส่ง",
    "queue_outbox_failed_24h": "ส่งไม่สำเร็จ 24 ชม.",
    "queue_domain_events_unpublished": "อีเวนต์รอเผยแพร่",
    "cron": "งานตามรอบ (cron)",
    "task": "งาน",
    "schedule": "รอบ",
    "last_status": "สถานะล่าสุด",
    "last_ok_at": "สำเร็จล่าสุด",
    "failures_24h": "พลาด 24 ชม.",
    "run": "รัน",
    "not_acquired": "ไม่ได้ล็อก (มี instance อื่นรัน)"
  },
  "telegram": {
    "title": "แจ้งเตือนผ่าน Telegram",
    "not_linked": "ยังไม่เชื่อมต่อ",
    "verified": "เชื่อมต่อแล้ว (chat {{chat}})",
    "link_button": "เชื่อม Telegram",
    "open_bot": "เปิดแชตกับบอท",
    "expires_in": "ลิงก์หมดอายุใน ~{{sec}} นาที",
    "unlink": "ยกเลิกการเชื่อมต่อ"
  },
  "filter": {
    "add": "+ ตัวกรอง",
    "remove": "ถอดตัวกรอง {{token}}",
    "field": "ชนิดตัวกรอง",
    "value": "ค่าตัวกรอง",
    "apply": "เพิ่ม"
  },
  "bulk": {
    "claim": "หยิบ",
    "transfer": "ส่งต่อ",
    "status": "สถานะ",
    "priority": "ความสำคัญ",
    "tags": "แท็ก",
    "snooze": "Snooze",
    "close": "ปิด",
    "working": "กำลังทำ…",
    "unavailable": "ยังใช้ไม่ได้ — ระบบยังไม่รองรับการสั่งเป็นชุด",
    "result_ok": "สำเร็จ {{ok}} ใบ",
    "result_failed": "ล้ม {{failed}} ใบ",
    "failed_toggle": "ใบที่ล้ม ({{count}})",
    "tag_add": "เพิ่มแท็ก",
    "tag_placeholder": "ชื่อแท็ก…",
    "snooze_submit": "พัก",
    "transfer_note": "บันทึกถึงทีมปลายทาง (ไม่บังคับ)"
  },
  "shortcut": {
    "title": "คีย์ลัด",
    "nav": "การเคลื่อนที่",
    "action": "การกระทำ",
    "other": "อื่น ๆ",
    "rows": {
      "move": "เลื่อนแถว",
      "open": "เปิดการ์ด",
      "search": "โฟกัสค้นหา",
      "palette": "เปิดคำสั่ง",
      "select": "เลือก/ยกเลิกแถว",
      "select_all": "เลือกทั้งหน้า",
      "clear": "ยกเลิกการเลือก",
      "close": "ปิดการ์ด",
      "claim": "หยิบการ์ด",
      "snooze": "พักการ์ด",
      "reply": "โฟกัสกล่องตอบ",
      "send": "ส่ง",
      "ai_draft": "ให้ AI ช่วยร่าง"
    }
  },
  "draft": {
    "saved_at": "บันทึกร่างอัตโนมัติ {{time}}"
  },
  "priorityLong": {
    "low": "ต่ำ",
    "normal": "ปกติ",
    "high": "สูง",
    "urgent": "ด่วนมาก"
  },
  "mobile": {
    "nav_label": "นำทางมือถือ",
    "tab_mine": "ของฉัน",
    "tab_team": "ทีม",
    "tab_triage": "Triage",
    "tab_notifications": "แจ้งเตือน",
    "select_view": "เลือกมุมมอง",
    "search": "ค้นหา",
    "swipe_hint": "ปัดแถวไปทางซ้ายเพื่อ snooze · ขวาเพื่อหยิบ",
    "row_actions": "การกระทำของแถว",
    "detail": "รายละเอียด",
    "detail_title": "รายละเอียดการ์ด",
    "status": "สถานะ",
    "holder": "ผู้ถือ",
    "due": "ครบกำหนด",
    "tags": "แท็ก",
    "attachments": "ไฟล์แนบ",
    "related": "การ์ดที่เกี่ยวข้อง",
    "files_count": "{{count}} ไฟล์",
    "cards_count": "{{count}} ใบ",
    "change_status": "เปลี่ยนสถานะ",
    "merge_link": "รวม / ลิงก์",
    "close_card": "ปิดการ์ด",
    "reply_customer": "ตอบลูกค้า",
    "internal_note": "โน้ตภายใน",
    "send_and_close": "ส่ง & ปิด",
    "composer_placeholder": "เขียนคำตอบถึงลูกค้า…",
    "composer_note_placeholder": "เขียนโน้ตภายใน…",
    "typing": "{{name}} กำลังพิมพ์…",
    "draft_saved": "ร่างถูกบันทึก",
    "ai_help": "ให้ AI ช่วยเขียน",
    "attach": "แนบไฟล์",
    "send": "ส่ง",
    "offline_banner": "ออฟไลน์ — กำลังดึงข้อมูลทุก {{count}} วินาที",
    "team_filter": "ทีม {{code}}",
    "urgent_first": "ด่วน+",
    "longest_wait": "รอนานสุด",
    "empty_unassigned_title": "ไม่มีการ์ดที่ยังไม่หยิบ",
    "empty_unassigned_desc": "ทีมเคลียร์คิวหมดแล้ว ลองดูการ์ดที่รอลูกค้าตอบ หรือเปิดการ์ดใหม่แทนลูกค้า",
    "empty_title": "ไม่มีการ์ดในมุมมองนี้",
    "empty_desc": "ลองเปลี่ยนมุมมองหรือเปิดการ์ดใหม่แทนลูกค้า",
    "open_new_card": "เปิดการ์ดใหม่",
    "view_team_queue": "ดูของทั้งทีม",
    "view_card": "ดู",
    "snooze_button": "Snooze"
  },
  "t64": {
    "banner_team_title": "ทีมงานกำลังดูแลอยู่",
    "banner_team_body": "คุณยังไม่ต้องทำอะไร ทีมงานจะตอบกลับให้เร็วที่สุด",
    "banner_customer_body": "ทีมงานรอข้อมูลเพิ่มเติมจากคุณอยู่",
    "banner_customer_cta": "ไปที่กล่องข้อความ",
    "banner_closed_title": "เรื่องนี้ปิดแล้ว",
    "banner_csat_cta": "ให้คะแนนการ์ดนี้",
    "chip_team": "ทีมงานกำลังดูแล",
    "act_reply": "ตอบกลับ",
    "act_close": "ปิดเรื่องนี้",
    "act_reopen": "เปิดเรื่องนี้อีกครั้ง",
    "act_cc": "ส่งสำเนาให้คนอื่นด้วย",
    "act_cc_help": "คนที่คุณใส่จะได้รับอีเมลแจ้งอัปเดตของเรื่องนี้",
    "close_confirm_title": "ปิดเรื่องนี้เลยไหม",
    "close_confirm_body": "ถ้ายังไม่หาย ค่อยเปิดใหม่ได้ในภายหลัง",
    "close_confirm_days": "เปิดใหม่ได้ภายใน {{days}} วันหลังปิด",
    "close_confirm_confirm": "ยืนยันปิดเรื่องนี้",
    "closed_panel_body": "เรื่องนี้ปิดแล้ว จึงพิมพ์ตอบกลับไม่ได้ ถ้ายังไม่ได้รับการแก้ไข สามารถเปิดเรื่องเดิมใหม่ หรือแจ้งเรื่องใหม่ได้",
    "closed_panel_reopen": "เปิดเรื่องนี้ใหม่",
    "closed_panel_new": "แจ้งเรื่องใหม่",
    "closed_409": "เรื่องนี้ถูกปิดไปแล้ว (อาจมีการปิดจากแท็บอื่น) — โหลดข้อมูลล่าสุดให้แล้ว",
    "handoff_dept_whole": "ส่งให้ทั้งแผนก: {{dept}}",
    "handoff_my_team": "ทีมของฉัน",
    "handoff_search_placeholder": "ค้นหาทีม…",
    "handoff_no_dept": "ไม่ระบุแผนก",
    "redact_title": "ปกปิดข้อมูลในข้อความนี้",
    "redact_action": "ปกปิดข้อมูลส่วนบุคคล",
    "redact_help": "ลากคลุมข้อความที่ต้องการปกปิด หรือกดปุ่มลัดด้านล่าง แล้วระบุเหตุผล",
    "redact_span": "เลือกไว้: ตัวอักษรที่ {{start}}–{{end}}",
    "redact_add_item": "เพิ่มช่วงที่เลือก",
    "redact_existing_title": "ปกปิดไว้แล้ว (จะไม่ทำซ้ำ)",
    "redact_revoke": "ถอนการปกปิด",
    "redact_revoke_403": "ต้องเป็นผู้ที่ทำเครื่องหมายไว้หรือผู้ดูแลระบบจึงจะถอนการปกปิดได้",
    "redact_submit": "ปกปิดข้อมูล",
    "redact_done": "ปกปิดข้อมูลเรียบร้อยแล้ว",
    "composer_apply_menu": "ส่งแล้วเปลี่ยนเป็น …",
    "composer_apply_select": "เลือกสถานะปลายทาง",
    "composer_apply_none": "ไม่เปลี่ยนสถานะ",
    "composer_auto_status": "ส่งแล้วระบบจะเปลี่ยนเป็น {{status}} ให้อัตโนมัติ",
    "email_subject_target": "อีเมลของบัญชี {{sub}} — ระบบค้นหาอีเมลที่ยืนยันแล้วผ่าน UWU ID",
    "email_notify_subject_label": "ส่งอีเมลถึงผู้แจ้งผ่าน UWU ID",
    "email_unavailable": "ยังไม่มีช่องทางอีเมลที่ใช้ส่งถึงผู้แจ้งได้ สามารถบันทึกคำตอบในระบบได้",
    "email_reply_saved_failed": "บันทึกคำตอบแล้ว แต่ส่งอีเมลไม่สำเร็จ โปรดตรวจสถานะการส่งก่อนดำเนินการต่อ",
    "email_notify_label": "ส่งอีเมลแจ้งผู้แจ้งด้วย",
    "email_notify_off_hint": "ไม่ส่งอีเมล — ผู้แจ้งจะเห็นในพอร์ทัลและได้รับแจ้งเตือนในระบบ",
    "email_notify_warn": "ผู้แจ้งรายนี้ไม่มีบัญชีสำหรับเข้าดูในระบบ ถ้าไม่ส่งอีเมลเขาจะไม่รู้ว่ามีคำตอบ",
    "timeline_email_skipped": "ไม่ได้ส่งอีเมล",
    "timeline_redacted_badge": "มีข้อมูลที่ถูกปกปิด",
    "redact_scope_unsupported": "เซิร์ฟเวอร์ยังไม่รองรับการปกปิดแบบซ่อนจากทุกคน จึงยังปกปิดข้อความนี้ไม่ได้ (แจ้งผู้ดูแลระบบ)"
  },
  "reports": {
    "nav": "รายงาน",
    "title": "รายงาน",
    "tabs_label": "แท็บรายงาน",
    "schedules_link": "รายงานประจำ",
    "schedules_title": "รายงานประจำ",
    "preset_group": "ช่วงเวลา",
    "preset_7d": "7 วัน",
    "preset_30d": "30 วัน",
    "preset_90d": "90 วัน",
    "preset_custom": "กำหนดเอง",
    "filter_from": "จาก",
    "filter_to": "ถึง",
    "filter_team": "ทีม",
    "filter_team_all": "ทุกทีมที่เห็นได้",
    "filter_service": "บริการ",
    "filter_service_all": "ทุกบริการ",
    "filter_granularity": "ความละเอียด",
    "gran_day": "รายวัน",
    "gran_week": "รายสัปดาห์",
    "gran_month": "รายเดือน",
    "tab_overview": "ภาพรวม",
    "tab_volume": "ปริมาณงาน",
    "tab_response_times": "เวลาตอบ",
    "tab_time_in_status": "เวลาในแต่ละสถานะ",
    "tab_backlog": "งานค้าง",
    "tab_csat": "CSAT",
    "tab_agents": "ภาระงานรายคน",
    "card_created": "งานเข้า",
    "card_resolved": "ปิดได้",
    "card_backlog": "งานค้างตอนนี้",
    "card_frt": "ตอบครั้งแรก (มัธยฐาน)",
    "card_frt_p90": "ตอบครั้งแรก p90",
    "card_frt_business": "ตอบครั้งแรกเวลาทำการ (มัธยฐาน)",
    "card_resolution": "เวลาปิด (มัธยฐาน)",
    "card_csat": "CSAT เฉลี่ย",
    "card_bounces": "อีเมลตีกลับ",
    "card_scope": "ขอบเขตที่เห็น",
    "card_created_resolved": "สรุปตัวเลขหลัก",
    "range_display": "ช่วง {{from}} – {{to}} · เวลาไทย [from,to) ปลายเปิด",
    "delta_title": "เทียบช่วงก่อนหน้า (ยาวเท่ากัน) จาก delta ของ API",
    "empty_value": "ยังไม่มีข้อมูลในช่วงนี้",
    "empty_data": "ยังไม่มีข้อมูลในช่วงนี้",
    "business_median_short": "เวลาทำการ (มัธยฐาน)",
    "business_p90_short": "เวลาทำการ p90",
    "business_source": "ที่มา: ticket_state_periods.business_seconds",
    "unavailable_business": "ไม่มีข้อมูลเวลาทำการ — business_seconds ขาดหาย {{n}} ใบ (unknown ไม่ใช่ 0)",
    "csat_satisfied": "พอใจ {{pct}}% จาก {{n}} คำตอบ",
    "csat_count": "จำนวนคำตอบ",
    "csat_pct": "% พอใจ (4-5)",
    "csat_by_team": "CSAT แยกตามทีม",
    "csat_no_team": "ไม่ทราบทีม",
    "bounces_complained": "ร้องเรียน (complaint) {{n}} ฉบับ",
    "scope_org": "ทั้งองค์กร",
    "scope_teams": "ตามสิทธิ์ของคุณ ({{n}} ทีม)",
    "volume_totals": "รวมในช่วง: เข้า {{created}} · ปิด {{resolved}}",
    "backlog_asof": "ข้อมูล ณ {{as_of}}",
    "backlog_total": "งานค้างรวม {{n}} ใบ",
    "backlog_oldest": "เก่าที่สุด {{days}} วัน",
    "backlog_bucket_days": "{{key}} วัน",
    "agents_unknown_note": "การปิดจากการรวมการ์ดนับ exact เฉพาะที่รู้ was_closed=false — มี {{n}} เหตุการณ์รวมการ์ดเก่าที่ไม่ทราบสถานะการปิด (ไม่ได้นับให้ใคร)",
    "agents_nonuser_note": "ปิดโดย automation/ระบบ {{n}} การ์ด (ไม่ผูกกับบุคคล)",
    "chart_table": "สลับเป็นตาราง",
    "chart_graph": "สลับเป็นกราฟ",
    "chart_max": "ค่ามากสุด",
    "chart_buckets": "ช่วง",
    "unit_minutes": "นาที",
    "unit_tickets": "ใบ",
    "csv_download": "ดาวน์โหลด CSV",
    "csv_loading": "กำลังเตรียมไฟล์…",
    "csv_done": "ดาวน์โหลดแล้ว",
    "csv_413": "ไฟล์ใหญ่เกินขีดที่ระบบให้ — แคบช่วงวันที่หรือกรองทีม/บริการแล้วลองอีกครั้ง",
    "csv_error": "ดาวน์โหลดไม่สำเร็จ ลองอีกครั้ง",
    "loading": "กำลังโหลด…",
    "error": "โหลดรายงานไม่สำเร็จ",
    "def_created": "จำนวนการ์ดที่ถูกสร้างในช่วง (ตามวันที่เปิดเรื่อง · เวลาไทย)",
    "def_resolved": "การ์ดที่ปิดสำเร็จในช่วง (ตาม closed_at · เวลาไทย)",
    "def_backlog": "การ์ดที่ยังไม่ปิด ณ ตอนนี้ — ไม่ใช่ตัวเลขในช่วง",
    "def_frt": "มัธยฐานของเวลาตั้งแต่เปิดเรื่องจนตอบครั้งแรก · เวลาไทย · ไม่ใช่ค่าเฉลี่ย",
    "def_frt_p90": "p90 ของเวลาตอบครั้งแรก (90% ของการ์ดตอบเร็วกว่าค่านี้) · เวลาไทย",
    "def_frt_business": "เหมือน FRT แต่นับเฉพาะเวลาทำการ จาก ticket_state_periods.business_seconds",
    "def_resolution": "มัธยฐานของเวลาตั้งแต่เปิดจนปิดการ์ด · เวลาไทย",
    "def_csat": "คะแนนเฉลี่ย 1-5 จากคำตอบ CSAT · % พอใจ = คะแนน 4-5 · แยกตามทีมของการ์ด",
    "def_bounces": "อีเมลตีกลับ (bounce) + ร้องเรียน (complaint) ในช่วง — นับจาก outbox.message_events ชนิด bounced/complained",
    "def_scope": "ขอบเขตข้อมูลตามสิทธิ์: staff เห็นทีมตัวเอง · หัวหน้าแผนกเห็นทั้งแผนก · ผู้ดูแลเห็นทั้งหมด",
    "def_created_resolved": "ตัวเลขสรุปของช่วงที่เลือก — กด 'สลับเป็นตาราง' เพื่อก๊อปตัวเลขไปใช้ต่อ",
    "def_volume_series": "อนุกรมรายวัน/สัปดาห์/เดือน (เริ่มวันจันทร์สำหรับรายสัปดาห์) ตามวันไทย",
    "def_time_in_status": "ผลรวมเวลาที่การ์ดอยู่ในแต่ละสถานะ แสดงเป็นมัธยฐานต่อการ์ด (clamp เข้าช่วงที่เลือก)",
    "def_backlog_buckets": "การ์ดที่ยังไม่ปิด ณ ตอนนี้ แบ่งตามช่วงอายุ (วันเต็ม · ไม่ซ้อนกัน)",
    "def_backlog_note": "อายุนับจากวันที่เปิดเรื่องถึง as_of · ช่วง [from,to) ไม่มีผลกับงานค้างปัจจุบัน",
    "def_agents": "การ์ดที่ปิดในช่วง + ข้อความตอบสาธารณะ ต่อคน · ทีมของการ์ดใช้ทีมผู้ถือปัจจุบัน (current_holder)",
    "table_day": "วัน",
    "table_created": "เข้า",
    "table_resolved": "ปิด",
    "table_status": "สถานะ",
    "table_tickets": "การ์ด",
    "table_median": "มัธยฐาน (นาที)",
    "table_p90": "p90 (นาที)",
    "table_total_sec": "รวม (วินาที)",
    "table_bucket": "ช่วงอายุ",
    "table_from_days": "เริ่ม (วัน)",
    "table_to_days": "สิ้นสุด (วัน)",
    "table_count": "จำนวน",
    "table_team": "ทีม",
    "table_avg": "เฉลี่ย",
    "table_satisfied": "พอใจ (%)",
    "table_agent": "เจ้าหน้าที่",
    "table_email": "อีเมล",
    "table_closed": "ปิดได้",
    "table_merged": "ปิดจากรวมการ์ด",
    "table_replies": "ตอบสาธารณะ",
    "table_metric": "ตัวชี้วัด",
    "table_value": "ค่า",
    "kind_overview": "ภาพรวม",
    "kind_volume": "ปริมาณงาน",
    "kind_response_times": "เวลาตอบ/เวลาปิด",
    "kind_time_in_status": "เวลาในแต่ละสถานะ",
    "kind_backlog": "งานค้าง",
    "kind_csat": "CSAT",
    "sch_create": "สร้างรายงานประจำ",
    "sch_empty": "ยังไม่มีรายงานประจำ",
    "sch_name": "ชื่อ",
    "sch_kind": "รายงาน",
    "sch_cadence": "ความถี่",
    "sch_cadence_daily": "รายวัน",
    "sch_cadence_weekly": "รายสัปดาห์",
    "sch_cadence_monthly": "รายเดือน",
    "sch_weekday": "วันของสัปดาห์",
    "sch_dom": "วันที่ของเดือน",
    "sch_day_of_month": "วันที่ {{day}}",
    "sch_hour_thai": "เวลาส่ง (เวลาไทย)",
    "sch_hour_utc_hint": "จะส่งเป็น {{hour}}:00 UTC",
    "sch_format": "รูปแบบอีเมล",
    "sch_format_summary": "สรุปในตัวอีเมล",
    "sch_format_csv": "แนบไฟล์ CSV",
    "sch_recipients": "ผู้รับ (อีเมลเจ้าหน้าที่ คั่นด้วยจุลภาค)",
    "sch_recipients_hint": "พิมพ์อีเมลหรือเลือกจากรายชื่อที่ระบบแนะนำ (GET /api/v1/users) — ทุกอีเมลต้องเป็นเจ้าหน้าที่ (backend ตรวจตอนบันทึก)",
    "sch_recipients_required": "ต้องระบุผู้รับอย่างน้อย 1 อีเมล",
    "sch_recipients_invalid": "มีอีเมลผู้รับรูปแบบไม่ถูกต้อง",
    "sch_team_required": "เจ้าหน้าที่ทั่วไปต้องเลือกทีมของตัวเอง (ทั้งองค์กร = ผู้ดูแลระบบเท่านั้น)",
    "sch_team_staff_hint": "ตั้งรายงานทั้งองค์กรได้เฉพาะผู้ดูแลระบบ",
    "sch_save_error": "บันทึกไม่สำเร็จ",
    "sch_submit": "บันทึก",
    "sch_cancel": "ยกเลิก",
    "sch_enabled": "เปิดใช้",
    "sch_disabled": "ปิดอยู่",
    "sch_edit": "แก้ไข",
    "sch_delete": "ลบ",
    "sch_confirm_delete": "ลบรายงานประจำนี้?",
    "sch_last_run": "รันล่าสุด: {{at}}",
    "sch_never": "ยังไม่เคยรัน",
    "wd_0": "อาทิตย์",
    "wd_1": "จันทร์",
    "wd_2": "อังคาร",
    "wd_3": "พุธ",
    "wd_4": "พฤหัสบดี",
    "wd_5": "ศุกร์",
    "wd_6": "เสาร์"
  },
  "t69": {
    "side_title": "ประสานงาน",
    "side_ask": "สอบถามผู้เกี่ยวข้อง",
    "side_new": "สอบถามแผนกหรือผู้เกี่ยวข้อง",
    "side_customer_hidden": "ลูกค้าไม่เห็นข้อความนี้",
    "side_empty": "ยังไม่มีการประสานงานในการ์ดนี้",
    "side_open": "เปิด",
    "side_closed": "ปิด",
    "side_last_reply": "ตอบล่าสุด",
    "side_back": "กลับรายการเธรด",
    "side_section": "ประสานงาน",
    "side_recipient_picker": "ค้นหาเจ้าหน้าที่ ทีม หรือแผนก",
    "side_recipient_hint": "ทีมและแผนกส่งเข้ากล่องกลางที่ตั้งค่าไว้ หรือกรอกอีเมลผู้เกี่ยวข้องด้านล่าง",
    "side_form_to": "ถึง (อีเมล)",
    "side_form_cc": "สำเนา (cc)",
    "side_form_subject": "หัวเรื่อง",
    "side_form_body": "ข้อความ",
    "side_form_send": "ส่งถาม",
    "side_form_warn": "คำเตือน: ลูกค้าไม่เห็นข้อความนี้ และระบบไม่แนบเนื้อหาของการ์ดให้อัตโนมัติ — ถ้าต้องการส่งข้อมูลให้คัดลอกเอง",
    "side_reply_label": "ตอบในเธรดประสานงาน",
    "side_reply_send": "ตอบในเธรด",
    "side_close_thread": "ปิดเธรด",
    "side_reopen_thread": "เปิดเธรดอีกครั้ง",
    "side_to_note": "คัดลอกเข้าโน้ตภายใน",
    "side_to_note_done": "คัดลอกเข้าโน้ตภายในแล้ว",
    "side_select_msg": "เลือกข้อความ",
    "side_dir_out": "ทีมถาม",
    "side_dir_in": "ตอบกลับ",
    "approval_section": "การอนุมัติของการ์ดนี้",
    "approval_bar": "รออนุมัติ {{received}}/{{needed}}",
    "approval_sent": "ส่งคำขออนุมัติแล้ว — รออีก {{n}} คน",
    "approval_waiting_names": "ยังไม่กด: {{names}}",
    "approval_note": "เหตุผล (ไม่บังคับ)",
    "approval_approve": "อนุมัติ",
    "approval_decline": "ไม่อนุมัติ",
    "approval_queue": "รอฉันอนุมัติ",
    "draft_conflict": "ร่างบนเซิร์ฟเวอร์ถูกแก้จากที่อื่นระหว่างที่คุณเขียน",
    "draft_keep_mine": "ใช้ของฉัน",
    "draft_use_server": "ใช้ของบนเซิร์ฟเวอร์",
    "draft_shared_by": "{{name}} กำลังร่างตอบอยู่",
    "draft_on_server": "ทุกเครื่อง"
  },
  "w8wf": {
    "needs_approval": "(ต้องอนุมัติ)",
    "apply_pending": "ส่งข้อความแล้ว — การเปลี่ยนสถานะต้องรออนุมัติ {{received}}/{{needed}}"
  },
  "mail": {
    "nav": "อีเมลของฉัน",
    "title": "อีเมลของฉัน",
    "not_found": "ไม่พบหน้านี้",
    "no_mailbox": "ยังไม่มีกล่องจดหมายสำหรับบัญชีนี้ — ติดต่อผู้ดูแลระบบเพื่อเปิดใช้งาน",
    "forbidden": "คุณไม่มีสิทธิ์เข้าถึงกล่องจดหมายนี้",
    "error_load": "โหลดอีเมลไม่สำเร็จ — ลองใหม่อีกครั้ง",
    "error_version": "ข้อมูลถูกแก้ไขจากที่อื่นระหว่างใช้งาน — รีเฟรชแล้วลองอีกครั้ง",
    "archived": "เก็บเข้าถาวรแล้ว",
    "unarchived": "นำกลับเข้ากล่องขาเข้าแล้ว",
    "trashed": "ย้ายเข้าถังขยะแล้ว",
    "hint": "j/k เลื่อน · Enter เปิด · e เก็บ · # ทิ้ง · r ตอบ · / ค้นหา · l ป้ายกำกับ",
    "select_hint": "เลือกอีเมลจากรายการด้านซ้ายเพื่ออ่าน",
    "labels": "ป้ายกำกับ",
    "folders": {
      "group": "โฟลเดอร์",
      "inbox": "กล่องขาเข้า",
      "starred": "ติดดาว",
      "sent": "ส่งแล้ว",
      "drafts": "ร่าง",
      "archive": "เก็บถาวร",
      "snoozed": "เลื่อนเตือน",
      "trash": "ถังขยะ",
      "spam": "สแปม"
    },
    "quota": {
      "label": "พื้นที่ใช้งาน",
      "used": "ใช้ไป {{used}} MB จาก {{total}} MB",
      "warn": "พื้นที่ใกล้เต็ม — ควรลบอีเมลเก่าหรือแจ้งผู้ดูแล"
    },
    "search": {
      "label": "ค้นหาอีเมล",
      "placeholder": "ค้นหาอีเมล… (เช่น from:ลูกค้า label:VIP)",
      "clear": "ล้าง",
      "help": "ไวยากรณ์",
      "help_title": "ฟิลด์ที่ใช้ได้",
      "help_free": "หรือพิมพ์คำค้นอิสระ (ค้นจากหัวเรื่อง/เนื้อหา/ผู้ส่ง)"
    },
    "list": {
      "empty": "ไม่มีอีเมล",
      "load_more": "โหลดเพิ่ม",
      "messages": "{{n}} ข้อความ",
      "starred": "ติดดาว",
      "no_subject": "(ไม่มีหัวเรื่อง)"
    },
    "view": {
      "to": "ถึง",
      "external": "ข้อความจากผู้ส่งภายนอก — ระวังลิงก์และไฟล์แนบ",
      "attachments": "มีไฟล์แนบ — ดาวน์โหลดได้จากไฟล์ .eml ทั้งฉบับ",
      "raw": "ดาวน์โหลด (.eml)",
      "size": "{{kb}} KB",
      "reply": "ตอบ",
      "label": "ป้ายกำกับ",
      "archive": "เก็บถาวร",
      "trash": "ทิ้ง",
      "back": "กลับไปรายการ",
      "preview_only": "ข้อความย่อ — เนื้อหาเต็มจะแสดงเมื่อโหลดต้นฉบับสำเร็จ",
      "full_loading": "กำลังโหลดเนื้อหาอีเมลต้นฉบับ…",
      "full_failed": "โหลดอีเมลต้นฉบับไม่สำเร็จ",
      "retry_original": "ลองใหม่"
    },
    "picker": {
      "title": "เลือกป้ายกำกับ",
      "empty": "ยังไม่มีป้ายกำกับ (สร้างได้ในหน้าตั้งค่าเมล)"
    },
    "account": {
      "switch_label": "กล่องจดหมาย",
      "fallback_notice": "กล่องที่เลือกไว้ไม่พร้อมใช้งานแล้ว — กลับไปใช้กล่องหลักให้แล้วเรียบร้อย",
      "send_not_allowed": "คุณไม่มีสิทธิ์ส่งอีเมลหรือจัดการร่างในกล่องจดหมายนี้"
    },
    "settings_link": "ตั้งค่า",
    "quarantine_link": "กักกัน",
    "back_inbox": "กลับกล่องจดหมาย"
  },
  "m410": {
    "compose_title": "เขียนจดหมาย",
    "from": "ผู้ส่ง",
    "to": "ถึง",
    "cc": "สำเนา",
    "bcc": "สำเนาลับ",
    "on_behalf_of": "{{address}} (ในนาม)",
    "email_placeholder": "พิมพ์อีเมลแล้วกด Enter",
    "remove": "ลบ",
    "invalid_email": "รูปแบบอีเมลไม่ถูกต้อง",
    "subject": "หัวเรื่อง",
    "body": "เนื้อหา",
    "body_placeholder": "เขียนข้อความ…",
    "attach_signature": "แนบลายเซ็น",
    "attach_quote": "แนบข้อความเดิมที่อ้างถึง",
    "quote_preview": "ข้อความอ้างอิง",
    "send": "ส่ง",
    "schedule": "กำหนดส่ง",
    "send_at": "วันเวลาที่ส่ง",
    "schedule_send": "จัดส่งตามเวลา",
    "need_recipient": "ต้องระบุผู้รับอย่างน้อยหนึ่งคน",
    "need_send_at": "ต้องระบุวันเวลาที่ส่ง",
    "draft_saved": "จดร่างแล้ว",
    "draft_save_failed": "บันทึกร่างไม่สำเร็จ",
    "send_failed": "ส่งไม่สำเร็จ",
    "undo_left": "เลิกทำได้ภายใน {{n}} วินาที",
    "undo": "เลิกทำ",
    "undo_done": "ยกเลิกการส่งแล้ว",
    "undo_failed": "เลิกทำไม่สำเร็จ",
    "loading": "กำลังโหลด…",
    "load_failed": "โหลดไม่สำเร็จ",
    "saved": "บันทึกแล้ว",
    "save_failed": "บันทึกไม่สำเร็จ",
    "delete": "ลบ",
    "settings_title": "ตั้งค่าจดหมาย",
    "signature_title": "ลายเซ็น",
    "signature_label": "ลายเซ็น (HTML)",
    "signature_placeholder": "<p>— ชื่อของคุณ</p>",
    "signature_save": "บันทึกลายเซ็น",
    "autoreply_title": "ตอบอัตโนมัติ",
    "autoreply_enable": "เปิดตอบอัตโนมัติ",
    "autoreply_from": "วันที่เริ่ม",
    "autoreply_until": "วันที่สิ้นสุด",
    "autoreply_subject": "หัวเรื่องตอบอัตโนมัติ",
    "autoreply_body_external": "ข้อความสำหรับภายนอก",
    "autoreply_body_internal": "ข้อความสำหรับภายใน",
    "autoreply_save": "บันทึกตอบอัตโนมัติ",
    "autoreply_need_dates": "ต้องระบุวันที่เริ่มและสิ้นสุด",
    "autoreply_bad_range": "วันที่สิ้นสุดต้องหลังวันที่เริ่ม",
    "labels_title": "ป้ายกำกับ",
    "labels_name": "ชื่อป้ายกำกับ",
    "labels_add": "เพิ่มป้ายกำกับ",
    "labels_empty": "ยังไม่มีป้ายกำกับ",
    "filter_title": "รายการตัวกรอง",
    "filter_new": "เพิ่มตัวกรองใหม่",
    "filter_op": "ตรงเงื่อนไข",
    "filter_op_and": "ทั้งหมด (AND)",
    "filter_op_or": "ข้อใดข้อหนึ่ง (OR)",
    "filter_field": "ฟิลด์",
    "filter_match": "เงื่อนไข contains/equals ฯลฯ",
    "filter_value": "ค่าที่ต้องการเทียบ",
    "filter_size_op": "มากกว่า/น้อยกว่า",
    "filter_date_op": "ก่อน/หลัง",
    "filter_date_value": "วันเวลา",
    "filter_add_condition": "เพิ่มเงื่อนไข",
    "filter_actions": "การกระทำ",
    "filter_save": "บันทึกตัวกรอง",
    "filter_enabled": "เปิดใช้งานตัวกรอง",
    "filter_need_condition": "ต้องกรอกเงื่อนไขอย่างน้อยหนึ่งข้อ",
    "filter_need_action": "ต้องเลือกการกระทำอย่างน้อยหนึ่งอย่าง",
    "filter_condition_value_required": "ต้องกรอกค่าของเงื่อนไขทุกข้อที่เลือกไว้",
    "filter_action_value_required": "ต้องกรอกค่าของการกระทำที่ติ๊กเลือกไว้",
    "filter_empty": "ยังไม่มีตัวกรอง",
    "field_from": "ผู้ส่ง",
    "field_to": "ผู้รับ",
    "field_cc": "สำเนา",
    "field_subject": "หัวเรื่อง",
    "field_body": "เนื้อหา",
    "field_attachment_name": "ชื่อไฟล์แนบ",
    "field_size": "ขนาด (ไบต์)",
    "field_has_attachment": "มีไฟล์แนบ",
    "field_is_external": "ผู้ส่งภายนอก",
    "field_spam_score_gte": "คะแนนสแปม ≥",
    "field_label": "ป้ายกำกับ",
    "field_received_at": "วันที่ได้รับ",
    "match_contains": "มีคำว่า",
    "match_equals": "เท่ากับ",
    "match_regex": "ตรงนิพจน์ (regex)",
    "match_starts": "ขึ้นต้นด้วย",
    "match_ends": "ลงท้ายด้วย",
    "match_before": "ก่อน",
    "match_after": "หลัง",
    "value_true": "ใช่",
    "value_false": "ไม่ใช่",
    "action_mark_read": "ทำเครื่องหมายอ่านแล้ว",
    "action_star": "ติดดาว",
    "action_mark_important": "สำคัญ",
    "action_archive": "เก็บถาวร",
    "action_trash": "ย้ายลงถังขยะ",
    "action_quarantine": "กักกัน",
    "action_snooze": "เลื่อนแสดง",
    "action_notify": "แจ้งเตือน",
    "action_stop": "หยุดประมวลผลถัดไป",
    "action_add_label": "เพิ่มป้ายกำกับ",
    "action_remove_label": "ถอดป้ายกำกับ",
    "action_forward_internal": "ส่งต่อภายใน",
    "action_auto_reply_template": "ตอบด้วยเทมเพลต",
    "action_convert_to_ticket": "แปลงเป็นการ์ด",
    "param_label_name": "ชื่อป้ายกำกับ",
    "param_snooze_hours": "จำนวนชั่วโมง",
    "param_forward_address": "ที่อยู่ส่งต่อ",
    "param_template_id": "รหัสเทมเพลต",
    "param_convert_codes": "รหัส service:team",
    "convert_placeholder": "SERVICE:TEAM",
    "quarantine_page_title": "กักกัน",
    "quarantine_title": "รายการที่ถูกกักกัน",
    "quarantine_preview": "ดูตัวอย่าง",
    "quarantine_release": "ปล่อย",
    "quarantine_not_spam": "ไม่ใช่สแปม",
    "quarantine_released": "ปล่อยออกจากกักกันแล้ว",
    "quarantine_expires": "หมดอายุ",
    "quarantine_empty": "ไม่มีรายการ",
    "quarantine_no_preview": "(ไม่มีเนื้อหาตัวอย่าง)",
    "unknown_sender": "(ไม่ทราบผู้ส่ง)",
    "no_subject": "(ไม่มีหัวเรื่อง)",
    "filter_edit": "แก้ไข",
    "filter_editing": "แก้ไขตัวกรอง",
    "filter_move_up": "ขึ้น",
    "filter_move_down": "ลง",
    "filter_updated": "แก้ไขตัวกรองแล้ว",
    "labels_rename": "เปลี่ยนชื่อ",
    "labels_rename_save": "บันทึกชื่อ",
    "labels_rename_cancel": "ยกเลิกการเปลี่ยนชื่อ",
    "undo_pending": "กำลังยกเลิกการส่ง — ระบบกำลังหยุดการส่ง ผลจะปรากฏในกล่อง ส่ง",
    "send_cancel_window_passed": "ขอยกเลิกช้าเกินหน้าต่าง — อีเมลกำลังถูกส่งไปแล้ว",
    "send_cycle_active": "ร่างนี้มีการส่งที่ยังไม่สิ้นสุด (หรือผลยังไม่แน่นอน) — รอผลหรือยกเลิกสำเร็จก่อน จึงจะส่งใหม่ได้"
  },
  "t92": {
    "pinned": "ปักหมุด",
    "pin": "ปักหมุด",
    "unpin": "เลิกปักหมุด",
    "bcc": "สำเนาลับ",
    "add_bcc": "เพิ่มสำเนาลับ",
    "bcc_invalid": "รูปแบบอีเมลไม่ถูกต้อง",
    "email_off_drop": "ปิดส่งอีเมลอยู่ — bcc กล่องผู้ส่ง และตัวเลือกลายเซ็นที่เลือกไว้จะไม่ถูกส่ง (ระบบไม่รับใช้ร่วมกับข้อความที่ไม่ส่งอีเมล)",
    "from": "จาก",
    "from_label": "กล่องผู้ส่ง",
    "from_default": "กล่องของการ์ด (ค่าเริ่มต้น)",
    "from_mine": "คุณส่งได้",
    "signature": "ลายเซ็น",
    "signature_label": "ลายเซ็นของคำตอบ",
    "signature_auto": "อัตโนมัติ — แนบท้ายอีเมล",
    "signature_inline": "แนบในเนื้อความ",
    "signature_none": "ไม่แนบลายเซ็น",
    "signature_none_unsupported": "สัญญาปัจจุบันยังส่งคำสั่งนี้ไม่ได้ — server ยังแนบลายเซ็นที่บันทึกไว้ให้อยู่",
    "signature_inline_preview": "ลายเซ็นจะแนบท้ายเนื้อความ (server จะไม่แนบซ้ำ)",
    "signature_inline_clear": "เลิกแนบลายเซ็นในเนื้อความ"
  },
  "uxc2": {
    "priority_load_error": "โหลดระดับความสำคัญของบริการไม่สำเร็จ",
    "fields_load_error": "โหลดรายการฟิลด์ไม่สำเร็จ",
    "field_sensitive": "ข้อมูลอ่อนไหว",
    "field_undefined": "ยังไม่มีนิยาม",
    "bulk_priority_unavailable": "การ์ดที่เลือกใช้ชุดระดับความสำคัญต่างกัน (หรือยังโหลดไม่ได้) — เลือกใบเดียวหรือรวมกลุ่มที่ใช้บริการเดียวกันก่อน",
    "transition": {
      "title": "เปลี่ยนสถานะเป็น “{{status}}”",
      "note_label": "หมายเหตุ (บันทึกเป็นโน้ตภายใน)",
      "required_mark": "*",
      "required_fields": "ฟิลด์ที่ต้องกรอกก่อนเปลี่ยนสถานะ",
      "field_required": "ต้องกรอกฟิลด์นี้ก่อนเปลี่ยนสถานะ",
      "approval_hint": "การเปลี่ยนสถานะนี้ต้องได้รับอนุมัติก่อน — เมื่อกดยืนยัน ระบบจะสร้างคำขออนุมัติและสถานะการ์ดยังไม่เปลี่ยนจนกว่าจะได้รับอนุมัติ",
      "children_hint": "การเปลี่ยนสถานะนี้ต้องปิดการ์ดลูกทุกใบก่อน (server จะตรวจซ้ำอีกครั้ง)",
      "stale": "การ์ดถูกแก้ไปแล้วระหว่างที่คุณกรอก — ข้อมูลที่กรอกไว้ยังอยู่ กด “โหลดใหม่” แล้วกดยืนยันอีกครั้ง",
      "reload": "โหลดใหม่",
      "submit": "ยืนยันเปลี่ยนสถานะ"
    }
  },
  "auto": {
    "col_name": "ชื่อกฎ",
    "col_when": "เมื่อ",
    "col_enabled": "เปิดใช้งาน",
    "priority": "ลำดับทำงาน",
    "enabled": "เปิดใช้งาน",
    "toggle": "เปิด/ปิดใช้งาน",
    "stop_processing": "หยุดหลังกฎนี้",
    "business_time": "นับเฉพาะเวลาทำการ",
    "move_up": "ขึ้น",
    "move_down": "ลง",
    "when": "เมื่อ",
    "if": "ถ้า",
    "then": "ให้",
    "and_word": "และ",
    "or_word": "หรือ",
    "mode_group": "โหมดแก้ไขกฎ",
    "mode_builder": "ตัวสร้างกฎ",
    "mode_json": "JSON ขั้นสูง",
    "conditions_json": "เงื่อนไข (JSON)",
    "actions_json": "การกระทำ (JSON)",
    "match_label": "การจับคู่เงื่อนไข",
    "match_all": "ตรงทุกข้อ",
    "match_any": "ข้อใดข้อหนึ่ง",
    "field": "ฟิลด์",
    "op_label": "เงื่อนไข",
    "action_label": "การกระทำ",
    "value": "ค่า",
    "value_to": "ถึง",
    "value_multi_hint": "ค่าคั่นด้วยลูกน้ำ",
    "cond_empty": "ทุกการ์ด (ยังไม่มีเงื่อนไข)",
    "add_condition": "เพิ่มเงื่อนไข",
    "add_action": "เพิ่มการกระทำ",
    "action_empty": "ยังไม่มีการกระทำ",
    "then_hint": "ทำอะไรเมื่อครบเงื่อนไข",
    "action_no_value": "ไม่ต้องตั้งค่าเพิ่ม",
    "assign_mode_label": "วิธีมอบหมาย",
    "recipient": "ผู้รับ",
    "team": "ทีม",
    "note": "โน้ต",
    "relative_minutes": "นับจากตอนนี้ (นาที)",
    "minutes": "นาที",
    "boolean_true": "ใช่",
    "boolean_false": "ไม่ใช่",
    "tag_add_new": "เพิ่มแท็กใหม่ \"{{name}}\"",
    "err_name": "ตั้งชื่อกฎก่อน",
    "err_no_action": "ต้องมีการกระทำอย่างน้อยหนึ่งอย่าง",
    "err_no_value": "กรอกค่าของเงื่อนไขให้ครบ",
    "err_op_field": "เงื่อนไข \"{{field}}\" ไม่รองรับกับฟิลด์นี้",
    "err_no_action_value": "ค่าของการกระทำยังไม่ครบ",
    "err_handoff_target": "เลือกทีมหรือผู้รับอย่างน้อยหนึ่งอย่าง",
    "err_json": "JSON ไม่ถูกต้อง (conditions/actions)",
    "err_conditions_schema": "conditions ไม่ตรง schema: {{msg}}",
    "err_actions_schema": "actions ไม่ตรง schema: {{msg}}",
    "fields": {
      "custom": "ฟิลด์กำหนดเอง",
      "service": "บริการ",
      "channel": "ช่องทาง",
      "status": "สถานะ",
      "status_type": "ชนิดสถานะ",
      "priority": "ระดับความสำคัญ",
      "holder_team": "ทีมผู้ถือ",
      "holder_user": "ผู้ถือเรื่อง",
      "tags": "แท็ก",
      "requester_email": "อีเมลผู้แจ้ง",
      "requester_domain": "โดเมนผู้แจ้ง",
      "requester_kind": "ประเภทผู้แจ้ง",
      "subject": "หัวเรื่อง",
      "body": "เนื้อหา",
      "mailbox": "กล่องจดหมาย",
      "age_minutes": "อายุการ์ด (นาที)",
      "message_count": "จำนวนข้อความ",
      "is_first_message": "เป็นข้อความแรก",
      "previous_status": "สถานะก่อนหน้า",
      "inside_business_hours": "อยู่ในเวลาทำการ",
      "has_parent": "มีการ์ดแม่",
      "unclaimed_minutes": "ไม่มีผู้รับ (นาที)",
      "inactive_minutes": "ไม่มีการเคลื่อนไหว (นาที)",
      "message_direction": "ทิศทางข้อความ",
      "ai.category": "หมวดที่ AI จัด",
      "ai.confidence": "ความมั่นใจ AI",
      "ai.sentiment": "อารมณ์จาก AI",
      "ai.urgency": "ความเร่งด่วนจาก AI",
      "language": "ภาษาการ์ด"
    },
    "ops": {
      "eq": "เท่ากับ",
      "neq": "ไม่เท่ากับ",
      "in": "อยู่ใน",
      "nin": "ไม่อยู่ใน",
      "contains": "มีคำว่า",
      "regex": "ตรงรูปแบบ",
      "gt": "มากกว่า",
      "lt": "น้อยกว่า",
      "between": "อยู่ระหว่าง",
      "is_empty": "ว่าง",
      "is_not_empty": "ไม่ว่าง"
    },
    "actions": {
      "set_status": "ตั้งสถานะเป็น",
      "set_priority": "ตั้งระดับความสำคัญเป็น",
      "add_tags": "เพิ่มแท็ก",
      "remove_tags": "ลบแท็ก",
      "assign": "มอบหมายให้",
      "handoff": "ส่งต่อให้",
      "escalate": "เลื่อนระดับความรุนแรง",
      "stop": "หยุดประมวลกฎถัดไป",
      "move_to_triage": "ย้ายไปหน้าคัดแยก",
      "set_due": "ตั้งกำหนดเสร็จ",
      "set_field": "ตั้งค่าฟิลด์",
      "notify": "แจ้งเตือน",
      "auto_reply": "ตอบกลับอัตโนมัติ",
      "add_note": "เพิ่มโน้ต",
      "add_watcher": "เพิ่มผู้ติดตาม",
      "webhook": "เรียก webhook"
    },
    "triggers": {
      "ticket.created": "การ์ดถูกสร้าง",
      "message.created": "มีข้อความใหม่",
      "ticket.status_changed": "สถานะเปลี่ยน",
      "ticket.holder_changed": "ผู้ถือเรื่องเปลี่ยน",
      "ticket.priority_changed": "ระดับความสำคัญเปลี่ยน",
      "ticket.tag_changed": "แท็กเปลี่ยน",
      "ticket.field_changed": "ฟิลด์เปลี่ยน",
      "ticket.child_closed": "การ์ดลูกถูกปิด",
      "time.inactive": "ไม่มีการเคลื่อนไหวต่อเนื่อง",
      "time.unclaimed": "ไม่มีผู้รับเรื่องต่อเนื่อง",
      "time.due_approaching": "ใกล้กำหนดเสร็จ",
      "time.overdue": "เกินกำหนดเสร็จ",
      "time.schedule": "ตามเวลาที่กำหนด",
      "ticket.csat_received": "ได้รับคะแนน CSAT",
      "ai.classified": "AI จัดหมวดแล้ว",
      "side_conversation.replied": "บทสนทนาข้างได้รับตอบกลับ"
    },
    "assign_modes": {
      "specific": "ผู้ใช้เฉพาะเจาะจง",
      "round_robin": "วนเวียนในทีม",
      "unassign": "ยกเลิกการมอบหมาย"
    },
    "dry": {
      "ticket": "รหัสการ์ดที่จะทดสอบ (เช่น AB-12345678901)",
      "run": "ทดสอบ",
      "matched": "ตรงเงื่อนไข — กฎจะทำงานกับการ์ดนี้",
      "not_matched": "ไม่ตรงเงื่อนไข — กฎจะข้ามการ์ดนี้",
      "reasons": "เหตุผลทีละเงื่อนไข",
      "actions": "สิ่งที่กฎจะทำ",
      "pass": "ตรง",
      "fail": "ไม่ตรง",
      "would": "(โหมดทดสอบ — ยังไม่ทำจริง)",
      "skipped": "ถูกข้าม: {{reason}}",
      "error": "ทำไม่สำเร็จ",
      "cond_empty": "ไม่มีเงื่อนไข (ตรงเสมอ)"
    },
    "err_json_to_builder": "โครง JSON นี้ (เงื่อนไขซ้อน and/or/not หรือการกระทำชนิดพิเศษ) ยังแปลงเป็นตัวสร้างกฎไม่ได้ — แก้ต่อใน JSON ได้เลย"
  },
  "tpl": {
    "col_name": "ชื่อเทมเพลต",
    "col_langs": "ภาษา",
    "col_kind": "ประเภท",
    "test_send": "ส่งอีเมลทดสอบ",
    "test_recipient": "ผู้รับทดสอบ (อีเมล)",
    "test_lang": "ภาษาที่ใช้ส่ง",
    "test_sent": "ส่งแล้วถึง {{email}} (ภาษา {{lang}}) ผ่าน provider ในเครื่อง — เช็คกล่องจดหมายของผู้รับ",
    "system_no_delete": "เทมเพลตของระบบลบไม่ได้ (ใช้งานอยู่ในกระบวนการอัตโนมัติ)",
    "kind_system": "ระบบ",
    "kind_canned": "แม่แบบ",
    "kind_signature": "ลายเซ็น",
    "kind_auto_reply": "ตอบกลับอัตโนมัติ",
    "name_placeholder": "ชื่อ",
    "subject_placeholder": "หัวเรื่อง",
    "body_placeholder": "เนื้อหา HTML ({{a.b}} escaped, {{{raw}}} unescaped)"
  },
  "settings": {
    "tab": {
      "security": "ความปลอดภัย (security)",
      "notification_defaults": "การแจ้งเตือนเริ่มต้น (notification_defaults)",
      "customization": "ปรับแต่งหน้า (customization)",
      "feature_flags": "ธงฟีเจอร์ (feature_flags)",
      "files": "ไฟล์แนบ (files)",
      "integrations": "เชื่อมต่อภายนอก (integrations)",
      "ai": "AI (ai)",
      "portal": "พอร์ทัล (portal)",
      "mail": "อีเมล (mail)"
    },
    "hint": {
      "security": "การบังคับใช้งานด้านความปลอดภัยของเซสชันและ IP allowlist",
      "notification_defaults": "ช่องทางเริ่มต้นต่อเหตุการณ์ของแต่ละบทบาท (ผู้ใช้ปรับทับได้เป็นรายคน)",
      "customization": "ชื่อระบบ โลโก้ และข้อความท้ายหน้า",
      "feature_flags": "ค่าตั้งต้นของ feature flags (ภาพรวมอยู่หน้า Feature flags)",
      "files": "ขนาดไฟล์แนบสูงสุด",
      "integrations": "การเชื่อมต่อภายนอก (ค่า secret ตั้งผ่านหน้าเฉพาะ)",
      "ai": "งบและการเปิดใช้ AI ต่อฟีเจอร์",
      "portal": "ค่าหน้า portal สำหรับผู้ไม่ได้ล็อกอิน",
      "mail": "ค่าอีเมลระดับระบบ (เช่น ผู้อนุมัติ eDiscovery)"
    },
    "json_view": "มุมมอง JSON",
    "json_value": "ค่าตั้ง (JSON)",
    "err_json": "JSON ไม่ถูกต้อง",
    "dirty": "ยังไม่ได้บันทึก",
    "notif": {
      "event": "เหตุการณ์"
    },
    "customization": {
      "title": "ชื่อระบบ",
      "logo_url": "URL โลโก้",
      "footer_html": "ข้อความท้ายหน้า (HTML)",
      "footer_hint": "แสดงทุกหน้า — เว้นว่างได้"
    },
    "security": {
      "reauth_max_age_sec": "อายุสูงสุดของการยืนยันตัวตนซ้ำ (วินาที)",
      "session_idle_min": "เซสชันหมดอายุถ้าไม่ใช้งาน (นาที)",
      "session_absolute_hours": "อายุสูงสุดของเซสชัน (ชั่วโมง)",
      "ip_allowlist": "IP allowlist ต่อบทบาท",
      "ip_placeholder": "10.0.0.0/8, 203.0.113.5 (คั่นด้วยลูกน้ำ)",
      "ip_hint": "เว้นว่าง = ไม่จำกัด IP สำหรับบทบาทนั้น"
    }
  },
  "mail_drafts": {
    "empty": "ยังไม่มีร่างอีเมล",
    "no_subject": "(ไม่มีหัวเรื่อง)",
    "delete": "ลบร่าง",
    "saved_attachment": "ไฟล์แนบที่บันทึกไว้"
  },
  "tasks": {
    "nav": "งานภายใน",
    "title": "งานภายใน",
    "my_work": "งานของฉัน",
    "group_assigned": "มอบหมายถึงฉัน",
    "group_watching": "ที่ฉันติดตาม",
    "group_created": "ที่ฉันสร้าง",
    "overdue": "เกินกำหนด",
    "overdue_count": "งานเกินกำหนด {{count}} ใบ",
    "projects": "โปรเจกต์",
    "no_projects": "ยังไม่มีโปรเจกต์",
    "new_project": "สร้างโปรเจกต์",
    "create_project": "สร้างโปรเจกต์",
    "project_name": "ชื่อโปรเจกต์",
    "project_description": "คำอธิบาย",
    "project_icon": "ไอคอน (อีโมจิ)",
    "project_color": "สี",
    "visibility": "การมองเห็น",
    "visibility_company": "ทั้งบริษัท",
    "visibility_private": "เฉพาะสมาชิก",
    "role_manager": "ผู้จัดการโปรเจกต์",
    "role_member": "สมาชิก",
    "role_viewer": "ดูอย่างเดียว",
    "counts_open": "เปิด {{count}}",
    "counts_done": "เสร็จ {{count}}",
    "counts_overdue": "เกินกำหนด {{count}}",
    "back": "กลับ",
    "view_toggle": "มุมมอง",
    "board": "บอร์ด",
    "list": "รายการ",
    "done_window": "งานที่เสร็จแล้วช่วง",
    "done_days_option": "{{count}} วันล่าสุด",
    "quick_add": "พิมพ์หัวข้องานแล้วกด Enter",
    "all": "ทั้งหมด",
    "all_labels": "ป้ายทั้งหมด",
    "filter_q": "ค้นหางาน",
    "filter_status": "กรองตามสถานะ",
    "filter_assignee": "กรองตามผู้รับผิดชอบ",
    "filter_label": "กรองตามป้ายกำกับ",
    "no_assignee_filter": "ผู้รับผิดชอบทั้งหมด",
    "move_conflict": "ย้ายการ์ดไม่สำเร็จ — กระดานถูกแก้ไขโดยคนอื่น กำลังโหลดข้อมูลใหม่",
    "edit_conflict": "บันทึกไม่สำเร็จ — งานถูกแก้ไขโดยคนอื่น กำลังโหลดข้อมูลใหม่",
    "detail_title": "รายละเอียดงาน",
    "field_status": "สถานะ",
    "field_title": "หัวข้อ",
    "field_description": "คำอธิบาย",
    "field_assignee": "ผู้รับผิดชอบ",
    "field_priority": "ความสำคัญ",
    "field_due": "กำหนดเสร็จ",
    "field_labels": "ป้ายกำกับ",
    "no_assignee": "ไม่มีผู้รับผิดชอบ",
    "no_due": "ไม่มีกำหนดส่ง",
    "priority_low": "ต่ำ",
    "priority_normal": "ปกติ",
    "priority_high": "สูง",
    "priority_urgent": "ด่วน",
    "subtasks": "งานย่อย",
    "subtask_add": "เพิ่มงานย่อย…",
    "subtask_done_toggle": "ทำเสร็จ",
    "subtask_reopen": "กลับไปทำต่อ",
    "checklist": "เช็กลิสต์",
    "checklist_add": "เพิ่มรายการเช็กลิสต์…",
    "checklist_delete": "ลบรายการ",
    "comments": "ความคิดเห็น",
    "comment_placeholder": "เขียนความคิดเห็น… (พิมพ์ @ชื่อ เพื่อกล่าวถึง)",
    "comment_post": "ส่งความคิดเห็น",
    "watchers": "ผู้ติดตาม",
    "watch_me": "ติดตามด้วยตัวเอง",
    "add_watcher": "เพิ่มผู้ติดตาม",
    "remove_watcher": "เลิกติดตาม",
    "history": "ประวัติ",
    "delete_task": "ลบงาน",
    "delete_confirm": "กดอีกครั้งเพื่อยืนยันการลบ",
    "created_by": "สร้างโดย",
    "event_task_created": "สร้างงาน",
    "event_task_edited": "แก้ไขงาน",
    "event_task_status_changed": "เปลี่ยนสถานะ",
    "event_task_assigned": "มอบหมายผู้รับผิดชอบ",
    "event_task_due_changed": "เปลี่ยนกำหนดเสร็จ",
    "event_task_priority_changed": "เปลี่ยนความสำคัญ",
    "event_task_moved": "ย้ายลำดับการ์ด",
    "event_task_comment_added": "แสดงความคิดเห็น",
    "event_task_deleted": "ลบงาน",
    "event_checklist_added": "เพิ่มรายการเช็กลิสต์",
    "event_checklist_done": "ติ๊กเช็กลิสต์",
    "event_label_changed": "เปลี่ยนป้ายกำกับ",
    "event_watcher_added": "เพิ่มผู้ติดตาม",
    "attach_title": "ไฟล์แนบ",
    "attach_upload": "อัปโหลดไฟล์",
    "attach_uploading": "กำลังอัปโหลด… {{pct}}%",
    "attach_delete": "ลบไฟล์แนบ",
    "attach_empty": "ยังไม่มีไฟล์แนบ",
    "tickets_title": "การ์ดลูกค้าที่เชื่อม",
    "tickets_empty": "ยังไม่มีการ์ดที่เชื่อมกับงานนี้",
    "tickets_open": "เปิดการ์ด",
    "ticket_create": "สร้างการ์ดจากงานนี้",
    "ticket_service": "รหัสบริการ",
    "ticket_service_placeholder": "เลือกบริการ",
    "ticket_team": "ทีม (ไม่บังคับ)",
    "ticket_team_none": "ไม่ระบุทีม",
    "ticket_subject": "หัวข้อการ์ด",
    "ticket_body_preview": "ตัวอย่างเนื้อหาที่จะส่ง",
    "ticket_body_note": "ระบบจะรวมรายละเอียดงานด้านบน พร้อมลิงก์กลับไปยังงานนี้ให้โดยอัตโนมัติ",
    "ticket_create_submit": "สร้างการ์ด",
    "ticket_already_linked": "ลิงก์การ์ดนี้ไปแล้ว",
    "report_tab": "รายงาน",
    "report_workload": "ภาระงานต่อคน",
    "report_name": "ชื่อ",
    "report_holding": "กำลังถือ",
    "report_overdue_col": "เกินกำหนด",
    "report_overdue_title": "งานเลยกำหนด",
    "report_overdue_empty": "ไม่มีงานเลยกำหนด",
    "report_done_per_week": "งานที่เสร็จต่อสัปดาห์ (8 สัปดาห์ล่าสุด)",
    "report_not_found": "ไม่พบรายงาน — โปรเจกต์นี้เป็นส่วนตัวและคุณไม่ใช่สมาชิก"
  }
}
